// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:13.634Z
// Property: Fountain Lake (ID: 6767906449165605)
// Collections: 31 amenities, 6 floorplans (live), 39 photos, 67 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165605",
  "property_external_id": "5w02d4n",
  "property_zillow_url": "https://www.zillow.com/b/fountain-lake-edmond-ok-65cLXr",
  "property_apartments_url": "https://www.apartments.com/fountain-lake-edmond-ok/5w02d4n/",
  "property_google_business_url": "https://www.google.com/maps/place/Fountain+Lake/data=!4m2!3m1!1s0x0:0xf6c6b9f40daad3fd?sa=X&ved=2ahUKEwjqkOew-bySAxVQlGoFHbEzCCIQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fountain-lake",
  "property_name": "Fountain Lake",
  "property_website_url": "https://www.caseusa.com/apartments/ok/edmond/fountain-lake/",
  "property_domain": null,
  "property_address": "14025 N. Eastern Ave.",
  "property_full_address": "14025 N. Eastern Ave., Edmond, OK, 73013",
  "property_address_1": "14025 N. Eastern Ave.",
  "property_address_2": null,
  "property_address_city": "Edmond",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73013",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Edmond",
  "property_address_latitude": "35.6125",
  "property_address_longitude": "-97.4809",
  "property_email": "fountainlake@caseusa.com",
  "property_phone": "(405) 645-9102",
  "property_call_tracking_phone": "855-520-0474",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Fountain Lake in Edmond, Oklahoma, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans, and enjoy resort-style amenities, including a refreshing pool, fitness center, and tranquil courtyard. Your ideal home awaits—check our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Fountain Lake, your oasis in the heart of Edmond, Oklahoma! Our beautifully designed apartment community features a selection of thoughtfully crafted floor plans, including spacious one and two-bedroom options, perfect for anyone seeking comfort and convenience. With a host of luxurious amenities at your fingertips, you’ll enjoy a lifestyle that combines relaxation and activity. \n\nDive into our sparkling pool, stay fit in our state-of-the-art fitness center, or unwind in the inviting clubhouse. Take advantage of our business center for remote work needs, and enjoy hassle-free package service. Our dedicated maintenance and property management teams are on-site to ensure your living experience is seamless and enjoyable.\n\nEmbrace the outdoors in our beautifully landscaped courtyard featuring a tranquil pond, grill, and picnic area that invites you to relax and connect with neighbors. Each apartment boasts modern essentials, including air conditioning, stainless steel appliances, and walk-in closets, while select units offer charming fireplaces and vaulted ceilings for added sophistication. Enjoy the convenience of washer/dryer hookups and high-speed internet access, making your daily life a breeze.\n\nWith on-site storage, gated access, and a variety of options to meet your lifestyle needs, Fountain Lake is more than just a place to live—it’s a community. Discover the perfect blend of comfort and convenience in Edmond. \n\nFind your new home today—browse our availability or schedule a tour to visit our community! Experience living at Fountain Lake, where every day feels like a retreat.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-c632-712e-abaa-3f645ec7c397.webp",
  "property_featured_image_media": {
    "alt_text": "View from a balcony overlooking the community's outdoor amenities, including grills and seating areas.",
    "public_id": "019cfb41-c632-712e-abaa-3f645ec7c397",
    "storage_key": "property/6767906449165605/019cfb41-c632-712e-abaa-3f645ec7c397.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "530",
  "property_year_built": "2009",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.49056603773585",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Up to two pets per home; breed restrictions apply; pets are subject to management approval.",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://fountainlakeapartmentsedmond.securecafe.com/onlineleasing/fountain-lake-i-ii/floorplans.aspx",
  "property_resident_portal_url": "https://fountainlakeapartmentsedmond.securecafe.com/residentservices/fountain-lake-i-ii/userlogin.aspx",
  "property_apply_now_url": "https://fountainlakeapartmentsedmond.securecafe.com/onlineleasing/fountain-lake-i-ii/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-9680-739f-a5a5-8a5fdc299fae.webp",
  "property_primary_logo_media": {
    "alt_text": "Fountain Lake Apartments logo",
    "public_id": "019cfb40-9680-739f-a5a5-8a5fdc299fae",
    "storage_key": "property/6767906449165605/019cfb40-9680-739f-a5a5-8a5fdc299fae.webp",
    "width": 600,
    "height": 218
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-a5da-7319-8624-87b299370850.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb41-a5da-7319-8624-87b299370850",
    "storage_key": "property/6767906449165605/019cfb41-a5da-7319-8624-87b299370850.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-d77d-7128-ac82-278fbdbb7d1a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Fountain Lake apartments logo",
    "public_id": "019cfb41-d77d-7128-ac82-278fbdbb7d1a",
    "storage_key": "property/6767906449165605/019cfb41-d77d-7128-ac82-278fbdbb7d1a.webp",
    "width": 600,
    "height": 218
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-deed-7480-bdae-ab3f894ad648.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Fountain Lake apartments logo",
    "public_id": "019cfb41-deed-7480-bdae-ab3f894ad648",
    "storage_key": "property/6767906449165605/019cfb41-deed-7480-bdae-ab3f894ad648.webp",
    "width": 600,
    "height": 218
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#556771",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#549ec9",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1079 - 1419",
  "property_price_min": "1079",
  "property_price_max": "1419",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/FountainLakeApts/photos/d41d8cd9/1709621443749447/",
  "property_instagram_url": "https://www.instagram.com/fountainlakeapts/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_YmuJSsfsocR_dOqDfS5xvY",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartment+Complex&find_loc=Edmond%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/@fountain.lake.apt",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Fountain Lake",
  "property_home_romance_title": "Embrace Life in Your Perfect Apartment Oasis",
  "property_home_amenities_blurb": "At Fountain Lake in Edmond, Oklahoma, every day feels like a retreat. Choose from spacious one or two-bedroom floor plans, featuring luxurious vaulted ceilings and gourmet kitchens. Enjoy 24-hour access to the pool and fitness center, or unwind by the peaceful pond. Experience a lifestyle that perfectly blends comfort and convenience!",
  "property_home_floorplans_blurb": "Welcome to Fountain Lake in Edmond, Oklahoma, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom floor plans, each tailored to elevate your living experience. Dive into luxury living and browse our available apartment homes today to find your ideal sanctuary. Your oasis awaits!",
  "property_home_gallery_blurb": "At Fountain Lake in Edmond, Oklahoma, modern living meets serene comfort. Choose from spacious one or two-bedroom floor plans featuring gourmet kitchens and impressive vaulted ceilings. Enjoy amenities like a fitness center, peaceful ponds, and 24-hour leasing. Picture yourself relaxing on your balcony or by the grill—your perfect home awaits!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Edmond, Oklahoma, Fountain Lake offers stylish one and two-bedroom apartments designed for comfort and convenience. Immerse yourself in the vibrant neighborhood, where local favorites and hidden gems await. Uncover everything our community has to offer and elevate your living experience at Fountain Lake.",
  "property_home_reviews_blurb": "Experience unparalleled comfort at Fountain Lake in Edmond, where spacious one-bedroom apartments boast luxury finishes and unbeatable rates. With amenities like pristine pools and convenient gym facilities, our community is a haven for relaxation. “I can honestly say all my needs and expectations are met every day.\" See what our residents have to say!",
  "property_neighborhood_blurb": "Nestled in the heart of Edmond, Fountain Lake offers more than just modern one and two-bedroom floor plans. Enrich your lifestyle with top-notch educational institutions like Orvis Risner, Cimarron Middle School, and Memorial High School right around the corner. Uncover the vibrant community and local favorites waiting at your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Fountain Lake in Edmond, Oklahoma, every detail is crafted for your comfort. Enjoy refreshing dips in the pool, energizing workouts in the fitness center, or relaxing evenings by the pond. With spacious floor plans and modern amenities like stainless steel appliances and a picturesque picnic area, your ideal lifestyle awaits.",
  "property_applynow_blurb": "At Fountain Lake in Edmond, Oklahoma, choose from spacious one and two-bedroom floor plans designed for comfort and style. Enjoy resort-style amenities including a shimmering pool, modern fitness center, and serene picnic areas by the pond. Ready to elevate your living experience? Secure your new home and lease online today!",
  "property_contactus_blurb": "At Fountain Lake in Edmond, Oklahoma, we offer an array of thoughtfully designed one- and two-bedroom apartments, tailored to fit your lifestyle. With stunning views and modern amenities, your perfect home awaits. Have questions? Contact our leasing team today and let us help you find your ideal living space!",
  "property_faqs_blurb": "At Fountain Lake in Edmond, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Curious about our vibrant community? Delve into our FAQs page to uncover the insights you need to make the best choice for your next home. Your journey starts here!",
  "property_floorplans_blurb": "At Fountain Lake in Edmond, Oklahoma, find the ideal blend of comfort and style in our thoughtfully designed one and two-bedroom floor plans. Each layout maximizes space and light, ensuring a welcoming atmosphere. Browse our available apartment homes today and secure the perfect floor plan tailored just for you.",
  "property_gallery_blurb": "At Fountain Lake in Edmond, Oklahoma, life is a canvas—filled with vibrant one and two-bedroom floor plans and breathtaking amenities. Picture sunny days by the pool, evenings in a grill-ready courtyard, and cozy nights by your fireplace. Immerse yourself in comfort and community; your dream home awaits!",
  "property_interactivemap_blurb": "At Fountain Lake in Edmond, Oklahoma, embrace a vibrant lifestyle in stylish one- and two-bedroom apartments, complete with high-end amenities like a sparkling pool, expansive fitness center, and serene picnic area by the pond. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Fountain Lake in Edmond, Oklahoma, your cozy retreat awaits! Enjoy serene lakeside views and vibrant community amenities tailored for comfort. Plus, we invite your furry friends to join you—reach out to our leasing office for pet details. Embrace a lifestyle where home and nature harmoniously blend!",
  "property_referafriend_blurb": "At Fountain Lake in Edmond, Oklahoma, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Share the joy of living here—great friends make great neighbors! Refer a friend and invite them to experience serene lakeside living today!",
  "property_residentaccess_blurb": "Welcome to Fountain Lake in Edmond, Oklahoma, where comfort meets convenience. With spacious one and two-bedroom floor plans, your ideal home awaits. Access your resident portal easily to manage rent payments, schedule maintenance, and embrace a hassle-free lifestyle. Your vibrant community is just a click away!",
  "property_reviews_blurb": "At Fountain Lake in Edmond, our residents rave about the spacious, luxury apartments and exceptional service. One resident said, “I’ve never been happier in an apartment,” highlighting the stunning appliances and serene atmosphere. With top-notch amenities and a prime location near UCO and OCU, you'll love calling us home!",
  "property_created_at": "1753982384429",
  "property_scheduletour_blurb": "At Fountain Lake in Edmond, Oklahoma, choose from thoughtfully designed one and two-bedroom floor plans, tailored for your lifestyle. Ready to experience the tranquility and beauty of our community? Schedule a tour today and hear firsthand from our residents why Fountain Lake is the perfect place to call home!",
  "property_thankyou_blurb": "Thank you for reaching out to Fountain Lake in Edmond, Oklahoma! Our inviting one- and two-bedroom floor plans are designed for your comfort and style. A dedicated team member will be in touch shortly to assist you in finding your perfect home. Stay tuned for more information about our community!",
  "property_virtualtours_blurb": "At Fountain Lake in Edmond, Oklahoma, your dream home awaits with spacious one and two-bedroom floor plans tailored to your lifestyle. Experience our vibrant community and scenic views from the comfort of your future home. Ready to find your perfect fit? Take a virtual tour of our apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Fountain Lake",
  "property_seo_title_home": "Fountain Lake | Apartments in Edmond, Oklahoma",
  "property_seo_description_home": "Experience comfort and convenience at Fountain Lake in Edmond, OK. Choose your ideal floor plan and enjoy amenities like a pool, fitness center, and scenic picnic areas.",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Edmond, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal home at Fountain Lake in Edmond, OK! Check out our unique one and two-bedroom floor plans and choose the perfect fit for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Edmond, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience the best of Edmond at Fountain Lake! Enjoy a resort-style pool, state-of-the-art fitness center, and spacious homes with modern features. Join us!",
  "property_seo_title_gallery": "Gallery | Apartments in Edmond, Oklahoma",
  "property_seo_description_gallery": "\"Capture the essence of luxury living at Fountain Lake in Edmond, OK. Enjoy scenic views, modern amenities, and spacious floor plans—picture your new home today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Fountain Lake Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Fountain Lake in Edmond, OK. Take a virtual tour of our stunning one and two-bedroom apartments today and find your perfect home!",
  "property_seo_title_interactivemap": "Interactive Map | Fountain Lake Apartments",
  "property_seo_description_interactivemap": "\"Find your perfect home at Fountain Lake in Edmond, OK! Check out our interactive map for available one and two-bedroom apartments with fabulous amenities.\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Edmond, Oklahoma",
  "property_seo_description_neighborhood": "Experience Edmond living at Fountain Lake. Dive into local hotspots and scenic views just outside your door. Your vibrant neighborhood awaits—discover it today!",
  "property_seo_title_contact": "Contact Us | Fountain Lake",
  "property_seo_description_contact": "Looking for your perfect home in Edmond? Fountain Lake offers spacious one and two-bedroom floor plans. Have questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Edmond, Oklahoma",
  "property_seo_description_faqs": "Get the answers you need about Fountain Lake in Edmond, OK! From amenities to floor plans, our FAQs reveal what makes us the perfect place to call home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Edmond, Oklahoma",
  "property_seo_description_reviews": "Experience the charm of Fountain Lake in Edmond, OK! Check out resident reviews and find out why our vibrant community feels like home. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Edmond, Oklahoma",
  "property_seo_description_applynow": "\"Experience luxury living at Fountain Lake in Edmond, OK! Choose from spacious one or two-bedroom apartments, complete with top-notch amenities. Lease online today!\"",
  "property_seo_title_residentaccess": "Resident Access | Fountain Lake",
  "property_seo_description_residentaccess": "\"Stay connected at Fountain Lake! Log in to your resident portal for easy rent payments, maintenance requests, and all your community needs in Edmond, OK.\"",
  "property_seo_title_referafriend": "Refer A Friend | Fountain Lake",
  "property_seo_description_referafriend": "\"Refer a friend to Fountain Lake in Edmond, OK! Share the joy of lakeside living and community vibes—because great friends make the best neighbors!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Fountain Lake",
  "property_seo_description_scheduletour": "Experience the tranquility of Fountain Lake in Edmond, OK. Schedule your tour today and see why our community is the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | Fountain Lake",
  "property_seo_description_privacy": "At Fountain Lake in Edmond, seek reassurance in our commitment to your privacy. Learn how we protect your personal information—view our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Fountain Lake",
  "property_seo_description_accessibility": "At Fountain Lake in Edmond, OK, we prioritize accessibility for all. Join us in creating an inclusive community where everyone can thrive. Learn more!",
  "property_seo_title_sitemap": "Sitemap | Fountain Lake",
  "property_seo_description_sitemap": "Navigate your way to comfort and convenience at Fountain Lake in Edmond, OK. Check out our sitemap for easy access to all our community offerings!",
  "property_seo_title_thankyou": "Thank You | Fountain Lake",
  "property_seo_description_thankyou": "Thank you for connecting with Fountain Lake in Edmond! Your journey to vibrant community living starts here. Our team will reach out soon to assist you!",
  "property_seo_title_pets": "Pet Policy | Apartments in Edmond, Oklahoma",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865234197",
  "amenities": [
    {
      "id": "ec_ecd9326af76c02fa6b2f892f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432743",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38b176f7ba4a73b3b7130979",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396590",
      "title": "Outdoor Grilling Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_faf1ce3f3ef0dcd6602d35e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396591",
      "title": "Cyber Cafe with WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f97ed5a72a500aa7f4079a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396592",
      "title": "Limited Gate Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0d33e11055c78456384eb31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396593",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2acb4a2010486826f5dd6bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396594",
      "title": "Endurance Fitness Center with Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e31e77b42ca18ab163eadc26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396595",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63ed7ec83b52e08872cfd16a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396596",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8fee28d7ded96eb67e67a25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127396597",
      "title": "Resort-Inspired Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da97a846127a4b2187324057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432752",
      "title": "Lush, Well-Lit Courtyard Grounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c21512a34a10c5c8d9d9a145",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432764",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14bd69fccff4758301f7a9e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432767",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c76abb436c7afc0e24a36d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432772",
      "title": "Edmond School District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_746f92ba61dd160a3686fef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432778",
      "title": "Easy Access to I-35, I-240, and I-44",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56513ff6f1ef77e45182cd65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432784",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8a3e39c17734b61eed10a64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127451422",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee516a3ae699356f41d06d7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "128017307",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f0b249a82093f7aef057feb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "128042532",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f8f661987e13747473427a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432842",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78773cd007658d6c2d479b01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432817",
      "title": "*Vaulted Ceilings",
      "amount": "false",
      "description": "*In Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4d2eb9f676e0ab12cc6b5f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127398066",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_695d0a5397f9b3df9f1ea7dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127398067",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38f2c1ed42993dc3dc3a6a6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127398068",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a151a91b363e2353898a00c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127398072",
      "title": "*Patio/Balcony",
      "amount": "false",
      "description": "*In select floor plans",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79e7a32fd602ea5236b0233e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127398073",
      "title": "Side by Side Refrigerator with Filtered Water and Icemaker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57a87f2aeb6ca43a374edcb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127398074",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69a9c8c39e45927829b3fd55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432810",
      "title": "Large Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17828bd7b9daabb42e69b8d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432840",
      "title": "Contemporary Chef Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21a4b024df3df90f208ee3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432858",
      "title": "Modern Paint Colors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1681048d8d792d03e0685135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432860",
      "title": "Ceramic Tile Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0d5efd8e89c5bfb271fd060",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "yardi",
      "external_id": "127432868",
      "title": "*Extra Storage",
      "amount": "false",
      "description": "*In select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b37b1e3c-ad4e-4cc7-8201-7af8d4b60604",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-ef54-72aa-933d-de71cfb8c53a.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment community entrance with parking and landscaping.",
        "public_id": "019d2708-ef54-72aa-933d-de71cfb8c53a",
        "storage_key": "property/6767906449165605/019d2708-ef54-72aa-933d-de71cfb8c53a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Front exterior of a multifamily community with a brick entrance, landscaped grounds, and parking.",
      "link": "",
      "alt_text": "Exterior view of an apartment community entrance with parking and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-10f6-7752-9c2a-d1ee7421b2b6.webp"
    },
    {
      "id": "custom_7dc352bb-5eea-478d-baef-1b004b22937b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-ee72-70c8-a55d-3af6e2a22f69.webp",
      "image_media": {
        "alt_text": "Outdoor community grilling area with stone fireplace and benches.",
        "public_id": "019d2708-ee72-70c8-a55d-3af6e2a22f69",
        "storage_key": "property/6767906449165605/019d2708-ee72-70c8-a55d-3af6e2a22f69.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Community",
      "description": "Shared outdoor space with stone fireplace, built-in grills, and seating for residents.",
      "link": "",
      "alt_text": "Outdoor community grilling area with stone fireplace and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-12d2-703e-b942-399fff363d1f.webp"
    },
    {
      "id": "custom_3479c92e-4c9a-4a1e-ace2-52020166cb64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-ef4f-75fc-84eb-b50c7f3fa00c.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment community entrance with stone facade and manicured landscaping.",
        "public_id": "019d2708-ef4f-75fc-84eb-b50c7f3fa00c",
        "storage_key": "property/6767906449165605/019d2708-ef4f-75fc-84eb-b50c7f3fa00c.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Community",
      "description": "Showcase of the apartment community exterior with stone accents, a covered entry, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of an apartment community entrance with stone facade and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-108e-7660-ad7d-53de38453f2b.webp"
    },
    {
      "id": "custom_b9591bb2-b21b-4a33-b8a8-f0197eae77d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-ef4b-71f8-9d70-074dcf9c7f57.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with lounge chairs and shaded seating, surrounded by apartment buildings.",
        "public_id": "019d2708-ef4b-71f8-9d70-074dcf9c7f57",
        "storage_key": "property/6767906449165605/019d2708-ef4b-71f8-9d70-074dcf9c7f57.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor pool at a multifamily community, with lounge seating and tables, set among modern apartment buildings.",
      "link": "",
      "alt_text": "Outdoor pool area with lounge chairs and shaded seating, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165605/019cfb40-a9cc-7599-a0a0-77511fbe38b8.webp"
    },
    {
      "id": "custom_1d6e8b86-ef35-4b45-a3a2-31866e890aaa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-f6ec-742b-82dd-f80e5d5f0def.webp",
      "image_media": {
        "alt_text": "Fenced community playground with a slide, seesaw, and climbing structure on a grassy lawn.",
        "public_id": "019d2708-f6ec-742b-82dd-f80e5d5f0def",
        "storage_key": "property/6767906449165605/019d2708-f6ec-742b-82dd-f80e5d5f0def.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor community playground at the property with colorful play equipment on a grassy yard.",
      "link": "",
      "alt_text": "Fenced community playground with a slide, seesaw, and climbing structure on a grassy lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-318b-743b-b702-1ca8dc21fe9b.webp"
    },
    {
      "id": "custom_bef94c52-1d07-4dca-b129-6f5d6f7be01f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-f885-7622-a7a6-7c4e2d8571ab.webp",
      "image_media": {
        "alt_text": "Balcony view of a multi-building apartment community with green lawns and paved walkways.",
        "public_id": "019d2708-f885-7622-a7a6-7c4e2d8571ab",
        "storage_key": "property/6767906449165605/019d2708-f885-7622-a7a6-7c4e2d8571ab.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community featuring multiple buildings, balconies, and landscaped courtyards.",
      "link": "",
      "alt_text": "Balcony view of a multi-building apartment community with green lawns and paved walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-33b6-7271-b8d4-1132a9b0e0d4.webp"
    },
    {
      "id": "custom_9059333d-3b14-4cde-aee1-cf375d039393",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-f8f7-7467-bee0-77bfe8aa2dfc.webp",
      "image_media": {
        "alt_text": "Modern communal living area with curved gray sofa, fireplace, purple accent wall, and dining table.",
        "public_id": "019d2708-f8f7-7467-bee0-77bfe8aa2dfc",
        "storage_key": "property/6767906449165605/019d2708-f8f7-7467-bee0-77bfe8aa2dfc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stylish residents' lounge featuring a curved sectional, fireplace, and open dining area for gatherings.",
      "link": "",
      "alt_text": "Modern communal living area with curved gray sofa, fireplace, purple accent wall, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-24ee-754c-8e07-d79285026839.webp"
    },
    {
      "id": "custom_21c154f8-52a2-45d0-be57-231e97e9170b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2708-fb61-725b-81a8-511d275564df.webp",
      "image_media": {
        "alt_text": "Bright lobby with gray sectional sofa, fireplace, and modern chandelier.",
        "public_id": "019d2708-fb61-725b-81a8-511d275564df",
        "storage_key": "property/6767906449165605/019d2708-fb61-725b-81a8-511d275564df.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious resident lounge in a modern apartment community featuring a fireplace, ample seating, and large windows with natural light.",
      "link": "",
      "alt_text": "Bright lobby with gray sectional sofa, fireplace, and modern chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-6509-7507-90cc-c090418077d3.webp"
    },
    {
      "id": "custom_565319e7-d412-4904-81a7-2a115feb5a68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-0042-75e8-b367-eaf38f1d1bd7.webp",
      "image_media": {
        "alt_text": "Community lounge with workstation desk, screens, printer, and cozy seating nook.",
        "public_id": "019d2709-0042-75e8-b367-eaf38f1d1bd7",
        "storage_key": "property/6767906449165605/019d2709-0042-75e8-b367-eaf38f1d1bd7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A modern resident clubhouse featuring a tech workspace and a comfortable seating alcove.",
      "link": "",
      "alt_text": "Community lounge with workstation desk, screens, printer, and cozy seating nook.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-527e-733a-9df2-bcfc992cc5fe.webp"
    },
    {
      "id": "custom_1ac8fda6-d2c3-4982-9d16-24e753a65787",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-0088-779c-b4dc-49a90d70aa25.webp",
      "image_media": {
        "alt_text": "Indoor apartment gym with treadmills, weights, and a geometric mural.",
        "public_id": "019d2709-0088-779c-b4dc-49a90d70aa25",
        "storage_key": "property/6767906449165605/019d2709-0088-779c-b4dc-49a90d70aa25.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "On-site fitness center for residents with cardio machines, strength equipment, and modern decor.",
      "link": "",
      "alt_text": "Indoor apartment gym with treadmills, weights, and a geometric mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-4a99-74cf-812b-f1574169550a.webp"
    },
    {
      "id": "custom_a23e94de-c161-42f6-a607-e493cd2d49f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-00d2-72e1-8587-ba50167b8b3a.webp",
      "image_media": {
        "alt_text": "Indoor gym with four treadmills, water cooler, mirrors, and a mounted TV.",
        "public_id": "019d2709-00d2-72e1-8587-ba50167b8b3a",
        "storage_key": "property/6767906449165605/019d2709-00d2-72e1-8587-ba50167b8b3a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Well-equipped community gym at the property with cardio machines, mirrors, water station, and a wall-mounted TV.",
      "link": "",
      "alt_text": "Indoor gym with four treadmills, water cooler, mirrors, and a mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165605/019cfb40-a477-755c-a421-1eb3618b268c.webp"
    },
    {
      "id": "custom_36989738-d670-4cd8-9b3e-3faf5bf2898a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-03c4-7504-8644-08b17ea0d4d6.webp",
      "image_media": {
        "alt_text": "Bright living room in an apartment with beige sofa, a patterned armchair, and two round coffee tables.",
        "public_id": "019d2709-03c4-7504-8644-08b17ea0d4d6",
        "storage_key": "property/6767906449165605/019d2709-03c4-7504-8644-08b17ea0d4d6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room in a modern apartment with neutral decor, ample seating, and soft natural light.",
      "link": "",
      "alt_text": "Bright living room in an apartment with beige sofa, a patterned armchair, and two round coffee tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-1263-76f5-b8a1-9075e8763460.webp"
    },
    {
      "id": "custom_dc5e64de-84f7-4a4a-adcc-0228dd048895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-0927-72a8-a5ba-c22407fc843c.webp",
      "image_media": {
        "alt_text": "Bright living room in an apartment with a beige sofa, two round coffee tables, and a dining area in the back.",
        "public_id": "019d2709-0927-72a8-a5ba-c22407fc843c",
        "storage_key": "property/6767906449165605/019d2709-0927-72a8-a5ba-c22407fc843c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with natural light, modern furnishings, and a connected dining space.",
      "link": "",
      "alt_text": "Bright living room in an apartment with a beige sofa, two round coffee tables, and a dining area in the back.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-121a-77eb-b1e0-0e02de1286e1.webp"
    },
    {
      "id": "custom_4adc82c6-f706-4913-8963-3342f121a4ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-0a7f-7717-855b-ab22c9e4ae93.webp",
      "image_media": {
        "alt_text": "Bright apartment living room with a gray sofa, white media console, and large window with blinds.",
        "public_id": "019d2709-0a7f-7717-855b-ab22c9e4ae93",
        "storage_key": "property/6767906449165605/019d2709-0a7f-7717-855b-ab22c9e4ae93.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment living room with a gray sofa, white TV console, decorative pillows, and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Bright apartment living room with a gray sofa, white media console, and large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-120a-7023-84e6-aae6645cccb2.webp"
    },
    {
      "id": "custom_608c8ffa-573b-4fef-8ddf-e8a0b78175a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-0be3-75a9-a89c-ac64b3936241.webp",
      "image_media": {
        "alt_text": "Bright apartment bedroom with a pink tufted comforter, wall art, ceiling fan, and dresser near a window.",
        "public_id": "019d2709-0be3-75a9-a89c-ac64b3936241",
        "storage_key": "property/6767906449165605/019d2709-0be3-75a9-a89c-ac64b3936241.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a pink tufted comforter, wall art, and a dresser by a sunny window.",
      "link": "",
      "alt_text": "Bright apartment bedroom with a pink tufted comforter, wall art, ceiling fan, and dresser near a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-1196-7228-834c-ec13fe34b719.webp"
    },
    {
      "id": "custom_c0891f33-a6c3-4c57-9926-e960bd75610d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-0ddb-73af-b383-88da77ce6df3.webp",
      "image_media": {
        "alt_text": "Dining nook with round wooden table and four wicker chairs by large window with blinds.",
        "public_id": "019d2709-0ddb-73af-b383-88da77ce6df3",
        "storage_key": "property/6767906449165605/019d2709-0ddb-73af-b383-88da77ce6df3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright dining area in a modern apartment with a round wooden table, four wicker chairs, and large windows with sheer curtains.",
      "link": "",
      "alt_text": "Dining nook with round wooden table and four wicker chairs by large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-12b4-72a6-9e4c-12c4ed3bfcc8.webp"
    },
    {
      "id": "custom_3d4f2744-0037-40ae-b4fa-184e7c1a35da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-11bc-77b9-b75e-d6904c6b0ae7.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with sink, vanity, mirror, toilet, and shower curtain.",
        "public_id": "019d2709-11bc-77b9-b75e-d6904c6b0ae7",
        "storage_key": "property/6767906449165605/019d2709-11bc-77b9-b75e-d6904c6b0ae7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with wood vanity, beige countertop, mirror, toilet, and tub/shower.",
      "link": "",
      "alt_text": "Bathroom in an apartment with sink, vanity, mirror, toilet, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-15bb-7364-bbdb-590caec0c1a9.webp"
    },
    {
      "id": "custom_549b428d-1634-407a-bb7b-c214579f2744",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-1484-73ba-95ad-22be4e2101ad.webp",
      "image_media": {
        "alt_text": "Bright home office with a desk and black rolling chair near large windows with blinds.",
        "public_id": "019d2709-1484-73ba-95ad-22be4e2101ad",
        "storage_key": "property/6767906449165605/019d2709-1484-73ba-95ad-22be4e2101ad.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A modern apartment office with a sleek desk, rolling chair, and plenty of natural light from big windows.",
      "link": "",
      "alt_text": "Bright home office with a desk and black rolling chair near large windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-219f-762e-965b-7bb28834f353.webp"
    },
    {
      "id": "custom_6c7f08a5-d75c-4d38-a1a2-9ea21b521377",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-1547-7123-b385-05776659249b.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel stove and microwave, granite countertops, and a double sink.",
        "public_id": "019d2709-1547-7123-b385-05776659249b",
        "storage_key": "property/6767906449165605/019d2709-1547-7123-b385-05776659249b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern galley kitchen with granite countertops, stainless-steel appliances, and generous dark wood cabinetry.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel stove and microwave, granite countertops, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-238f-7209-877a-d72709bfb0c6.webp"
    },
    {
      "id": "custom_77257d2e-bd21-408f-9978-42eed28f2f89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-1657-747e-9185-c99a33399a67.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a wooden bed frame, matching dressers and nightstands, ceiling fan, and sheep wall art.",
        "public_id": "019d2709-1657-747e-9185-c99a33399a67",
        "storage_key": "property/6767906449165605/019d2709-1657-747e-9185-c99a33399a67.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Rustic-inspired bedroom in a modern apartment with wood furniture and soft natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a wooden bed frame, matching dressers and nightstands, ceiling fan, and sheep wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-4a3f-7060-9470-a918194caf8b.webp"
    },
    {
      "id": "custom_178706c8-a0b8-46a1-a8f2-9da93e730db6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-1b63-7696-a616-ff31379c100c.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sectional sofa, fireplace, and large windows.",
        "public_id": "019d2709-1b63-7696-a616-ff31379c100c",
        "storage_key": "property/6767906449165605/019d2709-1b63-7696-a616-ff31379c100c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room in a modern apartment with a neutral palette, stone fireplace, and abundant natural light.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sectional sofa, fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-24fe-77bc-bb84-7c6ca1cf2fff.webp"
    },
    {
      "id": "custom_ef65d387-08ae-4d64-8af0-f7af64f4215d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-1c6b-75ce-9489-08bc14d57dff.webp",
      "image_media": {
        "alt_text": "Furnished bedroom with wooden bed, two matching nightstands, dresser, ceiling fan, and window with blinds.",
        "public_id": "019d2709-1c6b-75ce-9489-08bc14d57dff",
        "storage_key": "property/6767906449165605/019d2709-1c6b-75ce-9489-08bc14d57dff.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy, neutral-toned bedroom in a modern apartment with coordinated wood furniture and soft lighting.",
      "link": "",
      "alt_text": "Furnished bedroom with wooden bed, two matching nightstands, dresser, ceiling fan, and window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-26f4-76d0-94d5-6fb298ae0157.webp"
    },
    {
      "id": "custom_285d130a-772b-46bb-899c-eca3c6dd90c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-1d48-75aa-8084-534342606cd7.webp",
      "image_media": {
        "alt_text": "Interior dining area in a furnished apartment with a wooden table, gray upholstered chairs, and a desk by large windows.",
        "public_id": "019d2709-1d48-75aa-8084-534342606cd7",
        "storage_key": "property/6767906449165605/019d2709-1d48-75aa-8084-534342606cd7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment dining area with a wooden table, gray chairs, and a window desk—great for small gatherings.",
      "link": "",
      "alt_text": "Interior dining area in a furnished apartment with a wooden table, gray upholstered chairs, and a desk by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-2844-70f8-8891-7c197ba3e919.webp"
    },
    {
      "id": "custom_4f6efc31-1b9d-46c1-aef3-0b19f03c4025",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-1ed3-73b1-9f77-3047e2edaeb5.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a dark wood bed, white bedding, ceiling fan, and dresser.",
        "public_id": "019d2709-1ed3-73b1-9f77-3047e2edaeb5",
        "storage_key": "property/6767906449165605/019d2709-1ed3-73b1-9f77-3047e2edaeb5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bedroom with white bedding, artwork, and dark wood furniture for a clean, stylish look.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with a dark wood bed, white bedding, ceiling fan, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-31eb-7439-9c4e-f4cb012c9073.webp"
    },
    {
      "id": "custom_1b91be9a-804a-405a-86bc-a56ea261a3a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-2378-70be-aa93-7c58fc581fed.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and towels in an apartment unit.",
        "public_id": "019d2709-2378-70be-aa93-7c58fc581fed",
        "storage_key": "property/6767906449165605/019d2709-2378-70be-aa93-7c58fc581fed.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with granite vanity, sink, and neatly arranged towels.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and towels in an apartment unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-4a70-716e-b384-c27df88f4679.webp"
    },
    {
      "id": "custom_d627c787-985c-4ac9-8cb5-ec0b160d6fbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-248c-770d-8e2e-3707c6c15976.webp",
      "image_media": {
        "alt_text": "Open apartment kitchen with granite counter, wooden cabinets, white appliances, and two bar stools.",
        "public_id": "019d2709-248c-770d-8e2e-3707c6c15976",
        "storage_key": "property/6767906449165605/019d2709-248c-770d-8e2e-3707c6c15976.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with granite counters, wooden cabinets, white appliances, and bar seating.",
      "link": "",
      "alt_text": "Open apartment kitchen with granite counter, wooden cabinets, white appliances, and two bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-3370-70cf-a2b8-ec7dc7f4022e.webp"
    },
    {
      "id": "custom_4d5cf460-98c5-4b24-9d09-2d2c813c0b7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-25db-713c-ac0d-c8a5b70b50e1.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a wooden bed, nightstand, ceiling fan, and window with sheer curtains.",
        "public_id": "019d2709-25db-713c-ac0d-c8a5b70b50e1",
        "storage_key": "property/6767906449165605/019d2709-25db-713c-ac0d-c8a5b70b50e1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior photo of a modern apartment bedroom featuring neutral tones, wood furnishings, and decorative shelving.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a wooden bed, nightstand, ceiling fan, and window with sheer curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-5183-769e-8a04-3bf9115abcb6.webp"
    },
    {
      "id": "custom_ee5ab20b-9927-49b2-8983-4fd5f4fa0687",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-27a2-72bd-80c9-667feda4fadd.webp",
      "image_media": {
        "alt_text": "Open-concept living room with beige sofa, patterned chair, and kitchen bar.",
        "public_id": "019d2709-27a2-72bd-80c9-667feda4fadd",
        "storage_key": "property/6767906449165605/019d2709-27a2-72bd-80c9-667feda4fadd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with neutral tones, a cozy sofa, accent chair, and a connected kitchen and dining space.",
      "link": "",
      "alt_text": "Open-concept living room with beige sofa, patterned chair, and kitchen bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-36f7-71ef-9ce6-253fe638779d.webp"
    },
    {
      "id": "custom_a610196f-d265-4c8f-bd24-10b8d22659f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-2bde-72a8-b5c5-80493f522d1e.webp",
      "image_media": {
        "alt_text": "Bright apartment living room with gray sofa, round fluffy ottoman, and dining area by large windows.",
        "public_id": "019d2709-2bde-72a8-b5c5-80493f522d1e",
        "storage_key": "property/6767906449165605/019d2709-2bde-72a8-b5c5-80493f522d1e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area in a modern apartment with a gray sofa, fluffy round ottoman, and dining space next to large windows.",
      "link": "",
      "alt_text": "Bright apartment living room with gray sofa, round fluffy ottoman, and dining area by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-3a98-7271-890c-a2585ba05f9a.webp"
    },
    {
      "id": "custom_e956b157-691a-42e4-a092-34499d569361",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-2d9b-759b-8099-b05c2b3b8414.webp",
      "image_media": {
        "alt_text": "Apartment kitchen with brown wooden cabinets, white appliances, and granite countertops.",
        "public_id": "019d2709-2d9b-759b-8099-b05c2b3b8414",
        "storage_key": "property/6767906449165605/019d2709-2d9b-759b-8099-b05c2b3b8414.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen with granite countertops, tall wooden cabinets, and white appliances.",
      "link": "",
      "alt_text": "Apartment kitchen with brown wooden cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-439b-710f-b8da-47e9d9d89d48.webp"
    },
    {
      "id": "custom_c1e51654-7454-4534-a97a-58699f68dc59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-2fec-7470-8b4b-2c3991552976.webp",
      "image_media": {
        "alt_text": "Bright living room with beige sofa, patterned chair, round coffee table, and a TV.",
        "public_id": "019d2709-2fec-7470-8b4b-2c3991552976",
        "storage_key": "property/6767906449165605/019d2709-2fec-7470-8b4b-2c3991552976.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment living room with neutral tones, large windows, and a sleek TV console.",
      "link": "",
      "alt_text": "Bright living room with beige sofa, patterned chair, round coffee table, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-44ec-76ef-9551-92313004d2de.webp"
    },
    {
      "id": "custom_e7bdb44e-fd5c-4a43-89de-05f23ef471f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-3081-749e-8886-706e38b5b468.webp",
      "image_media": {
        "alt_text": "Laundry closet with a washer and dryer next to a bathroom vanity.",
        "public_id": "019d2709-3081-749e-8886-706e38b5b468",
        "storage_key": "property/6767906449165605/019d2709-3081-749e-8886-706e38b5b468.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "In-unit laundry nook with a washer and dryer beside a bathroom vanity and countertop.",
      "link": "",
      "alt_text": "Laundry closet with a washer and dryer next to a bathroom vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-4473-71e8-9df0-131d014c5995.webp"
    },
    {
      "id": "custom_9c0293f9-f801-4743-b9fc-81a903e2804e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-359d-766d-85d9-ce0066b573d5.webp",
      "image_media": {
        "alt_text": "Bright apartment bathroom with granite vanity, mirror, and a shower-tub combo.",
        "public_id": "019d2709-359d-766d-85d9-ce0066b573d5",
        "storage_key": "property/6767906449165605/019d2709-359d-766d-85d9-ce0066b573d5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior image of an apartment bathroom with a granite countertop, dark wood cabinets, and a white tub/shower.",
      "link": "",
      "alt_text": "Bright apartment bathroom with granite vanity, mirror, and a shower-tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-46b8-7061-8269-2272432a3ad6.webp"
    },
    {
      "id": "custom_46e59c92-d224-4499-a1db-1fec14598ccf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-37f8-72c8-b195-7f3f3369f881.webp",
      "image_media": {
        "alt_text": "Bright kitchen in an apartment showing brown wooden cabinets, granite countertops, and white appliances.",
        "public_id": "019d2709-37f8-72c8-b195-7f3f3369f881",
        "storage_key": "property/6767906449165605/019d2709-37f8-72c8-b195-7f3f3369f881.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with granite counters, full-size white appliances, and ample cabinet space.",
      "link": "",
      "alt_text": "Bright kitchen in an apartment showing brown wooden cabinets, granite countertops, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-4750-7719-b1d1-ce84543063ab.webp"
    },
    {
      "id": "custom_ed40e20e-3d52-4470-aa2d-70f974094ee8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-3909-75f0-b5ba-683d8b9d9c61.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless appliances, island counter, and double sink.",
        "public_id": "019d2709-3909-75f0-b5ba-683d8b9d9c61",
        "storage_key": "property/6767906449165605/019d2709-3909-75f0-b5ba-683d8b9d9c61.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright kitchen in a modern apartment with granite-style counters, dark wood cabinets, stainless appliances, and a pass-through island.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless appliances, island counter, and double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-520c-71ad-ada2-b0f677af819c.webp"
    },
    {
      "id": "custom_6fb468bc-908b-460b-828d-257da82353df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-3957-716c-ae3f-16d82abdc1de.webp",
      "image_media": {
        "alt_text": "Small dining nook in an apartment with a round black table, two metal chairs, a plant, and wall art.",
        "public_id": "019d2709-3957-716c-ae3f-16d82abdc1de",
        "storage_key": "property/6767906449165605/019d2709-3957-716c-ae3f-16d82abdc1de.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Apartment",
      "description": "Cozy apartment dining area with two-seat table, modern decor, wall art, and greenery.",
      "link": "",
      "alt_text": "Small dining nook in an apartment with a round black table, two metal chairs, a plant, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-5263-704c-b7ab-29b5baf26212.webp"
    },
    {
      "id": "custom_ec1a766d-5ab6-4793-88a9-f18c2f3b619e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-410b-7506-9c07-a9fd9b100d4d.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a queen bed, nightstand, window, ceiling fan, and mirror.",
        "public_id": "019d2709-410b-7506-9c07-a9fd9b100d4d",
        "storage_key": "property/6767906449165605/019d2709-410b-7506-9c07-a9fd9b100d4d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom with a queen bed, dark wood furniture, window blinds, ceiling fan, and a full-length mirror.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with a queen bed, nightstand, window, ceiling fan, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-56ff-763a-8930-0790dbc95b0d.webp"
    },
    {
      "id": "custom_32a8dfd9-c699-4dd6-8cb9-e2ac62053887",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-4178-7038-bfe6-1d9d0ab4b9e4.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, cabinets, tub/shower, and toilet.",
        "public_id": "019d2709-4178-7038-bfe6-1d9d0ab4b9e4",
        "storage_key": "property/6767906449165605/019d2709-4178-7038-bfe6-1d9d0ab4b9e4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a tiled tub/shower, wood vanity, large mirror, and decorative plants.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, mirror, cabinets, tub/shower, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-59bb-7445-a975-f21cc5fcdbe4.webp"
    },
    {
      "id": "custom_bff24370-244a-4b9c-bf52-d9a066582de5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-4378-77ab-9e72-129314b526a3.webp",
      "image_media": {
        "alt_text": "Bathroom in apartment with sink, vanity, mirror, toilet, and shower-tub.",
        "public_id": "019d2709-4378-77ab-9e72-129314b526a3",
        "storage_key": "property/6767906449165605/019d2709-4378-77ab-9e72-129314b526a3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a single vanity, mirror, storage cabinet, and a shower-tub combo.",
      "link": "",
      "alt_text": "Bathroom in apartment with sink, vanity, mirror, toilet, and shower-tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-5a07-77fb-a10e-673c6aa3d522.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_53dd7dcc-9444-4e23-ada5-062c6f6722b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with multiple games to choose from, and a variety of drinks and appetizers. They also highlight the fun atmosphere, suitable for families and groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-4dd0-755b-ad6d-25906b40068d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4dd0-755b-ad6d-25906b40068d",
        "storage_key": "property/6767906449165605/019d2709-4dd0-755b-ad6d-25906b40068d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e51c3fa1faaa",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_32163171-4c71-4bc9-860e-ff25a2450b6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a fun day of pickleball, cornhole, drinks, and snacks. They also highlight the friendly staff, the perfect atmosphere for all ages, and the great experience for families and friends.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-4dd0-755b-ad6d-2320f55ff3b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4dd0-755b-ad6d-2320f55ff3b8",
        "storage_key": "property/6767906449165605/019d2709-4dd0-755b-ad6d-2320f55ff3b8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5567671",
      "poi_longitude": "-97.5089424",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e51c3fa1faaa",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1fc1f0c9-2d40-45cb-a3ce-537d77f20be7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of entertainment options, including bowling, arcade games, laser tag, and escape rooms, as well as pizza, wings, and drinks. They also highlight the fun atmosphere, suitable for families and birthday parties, and the friendly and helpful staff.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-4e2e-70ab-9f2c-49abed36a286.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4e2e-70ab-9f2c-49abed36a286",
        "storage_key": "property/6767906449165605/019d2709-4e2e-70ab-9f2c-49abed36a286.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e51c3fa1faaa",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_415e64c5-adbd-4c33-a50e-f3c34650301d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves excellent steaks, chicken fried steak, and rolls. They also highlight the generous portions, reasonable prices, and attentive service.\n\nSome reviews mention the atmosphere can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-4e32-7798-a48a-a2e68deff0c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4e32-7798-a48a-a2e68deff0c3",
        "storage_key": "property/6767906449165605/019d2709-4e32-7798-a48a-a2e68deff0c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e51c3fa1faaa",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0b5fb35b-6223-4315-8cad-5ea2b3ce8ad2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "4901 NE 122nd St, Edmond, OK 73013, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "People say this restaurant serves delicious southern fried chicken, meatloaf, and hashbrown casserole. They also highlight the affordable prices, the cozy and welcoming atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-532a-762b-8168-e9b165d0481f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-532a-762b-8168-e9b165d0481f",
        "storage_key": "property/6767906449165605/019d2709-532a-762b-8168-e9b165d0481f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ok/edmond/351/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=15158410616723402160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.5956279",
      "poi_longitude": "-97.4341583",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-478-7119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e51c3fa1faaa",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e51c3fa1faaa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXeXacgEisocRsO1OqSR-XdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a734db25-a903-434f-9b26-e0ecbdc45c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sprawling shopping center containing retailers, restaurant options & a 24-screen movie theater.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including clothing, shoes, and toys, as well as entertainment options like an arcade, movie theater, and aquarium. They also highlight the clean and safe environment, and the fun atmosphere for families.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-539b-753c-9a05-cfbfa29f9a0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-539b-753c-9a05-cfbfa29f9a0c",
        "storage_key": "property/6767906449165605/019d2709-539b-753c-9a05-cfbfa29f9a0c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8263-7636-80d2-104311ad91aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8263-7636-80d2-104311ad91aa",
        "storage_key": "property/6767906449165605/019d2709-8263-7636-80d2-104311ad91aa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fa9ae4da-92c9-4a4e-a5e4-e0eb71456b2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Avondale Dr, Nichols Hills, OK 73116, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Shoppers say this grocery store offers a unique shopping experience with fresh produce, a wide selection of wines, and an array of flowers. They also highlight the friendly and helpful staff, reasonable prices, and clean store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5325-72a7-8b47-09ec8a8c6331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5325-72a7-8b47-09ec8a8c6331",
        "storage_key": "property/6767906449165605/019d2709-5325-72a7-8b47-09ec8a8c6331.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/nichols-hills/461/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877173602117636080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.5376946",
      "poi_longitude": "-97.5310595",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-843-5655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8283-7336-a695-0e0c81f776e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8283-7336-a695-0e0c81f776e1",
        "storage_key": "property/6767906449165605/019d2709-8283-7336-a695-0e0c81f776e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaTG8SUasocR8E_qTPSgcF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_26805bb8-c689-4b86-9b60-94d604407e53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, meats, and seafood, as well as unique and hard-to-find items. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-53d1-7078-9b1e-5f3504cfff15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-53d1-7078-9b1e-5f3504cfff15",
        "storage_key": "property/6767906449165605/019d2709-53d1-7078-9b1e-5f3504cfff15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8283-7336-a695-0e0c81f776e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8283-7336-a695-0e0c81f776e1",
        "storage_key": "property/6767906449165605/019d2709-8283-7336-a695-0e0c81f776e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f5b10f99-dd88-4652-8267-c541df5232a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 W 15th St #124, Edmond, OK 73013, USA",
      "poi_short_description": "Supermarket featuring aisles of fresh groceries, baked goods and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-57b9-76cd-8a0b-cf1269a32885.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-57b9-76cd-8a0b-cf1269a32885",
        "storage_key": "property/6767906449165605/019d2709-57b9-76cd-8a0b-cf1269a32885.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428274884093566538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.6368691",
      "poi_longitude": "-97.5127608",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-330-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8283-7336-a695-0e0c81f776e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8283-7336-a695-0e0c81f776e1",
        "storage_key": "property/6767906449165605/019d2709-8283-7336-a695-0e0c81f776e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSeJIYgesocRSl4izw3214I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_82792f1c-8b76-47c1-bec5-14ea69cc34e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1901 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are willing to assist with any task. They also highlight the friendly and efficient customer service, and the clean and well-stocked store.\n\nSome reviews mention the staff can be difficult to locate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5801-7467-8941-150eefec708e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5801-7467-8941-150eefec708e",
        "storage_key": "property/6767906449165605/019d2709-5801-7467-8941-150eefec708e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Edmond/OK/Edmond/73013/3907?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451913410994265011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.6348467",
      "poi_longitude": "-97.4853011",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-330-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8263-7636-80d2-104311ad91aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8263-7636-80d2-104311ad91aa",
        "storage_key": "property/6767906449165605/019d2709-8263-7636-80d2-104311ad91aa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9xQ7Wf4esocRs1uAoFwWqUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_34a812a0-5b69-4869-8289-f774083b6fc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "University of Central Oklahoma",
      "poi_type": "Education",
      "poi_address": "100 N University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5a06-770c-8aaf-f0a5ae4b4ddb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5a06-770c-8aaf-f0a5ae4b4ddb",
        "storage_key": "property/6767906449165605/019d2709-5a06-770c-8aaf-f0a5ae4b4ddb.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.uco.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17296425383341636856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-central-oklahoma",
      "poi_latitude": "35.657506",
      "poi_longitude": "-97.4709491",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-974-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e93508b64e78",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZ0xm_BNr4cR-Lwg6j4_CfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ca5b30a9-1c98-475b-8375-df253dec5933",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5993-71eb-bb79-dae3f96b1328.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5993-71eb-bb79-dae3f96b1328",
        "storage_key": "property/6767906449165605/019d2709-5993-71eb-bb79-dae3f96b1328.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e93508b64e78",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cff58afe-d804-4dd4-9c0f-b1373faf9a90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Edmond Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "Popular, kid-friendly facility offering books for all ages, magazines, music, movies, programs, computers and toy areas.",
      "poi_long_description": "People say this public library offers a wide selection of books, including e-books and audiobooks available through the Libby app. They highlight the cozy and inviting atmosphere, and the helpful and friendly staff. They also like the convenient book reservation system and quick pick-up service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5c70-73da-ab69-029f1c106cdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5c70-73da-ab69-029f1c106cdb",
        "storage_key": "property/6767906449165605/019d2709-5c70-73da-ab69-029f1c106cdb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5308985467338173646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-library---metropolitan-library-system",
      "poi_latitude": "35.6542015",
      "poi_longitude": "-97.4778675",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-341-9282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e93508b64e78",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ73psmrMfsocRzixngidOrUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d340395c-7fed-4fc9-b532-68882ea25f27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "The Village Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10307 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Public library featuring DVDs and quiet areas for study and reading.",
      "poi_long_description": "People say this library offers a great selection of books and take-home kits. They highlight the friendly and helpful staff, and the willingness to go above and beyond. They also like the clean play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5d36-7406-875c-01903c7f5483.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5d36-7406-875c-01903c7f5483",
        "storage_key": "property/6767906449165605/019d2709-5d36-7406-875c-01903c7f5483.webp",
        "width": 1280,
        "height": 382
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6591062255135426801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-village-library---metropolitan-library-system",
      "poi_latitude": "35.5755065",
      "poi_longitude": "-97.5498468",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-755-0710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e93508b64e78",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt5LnnJMbsocR8QjVOTMoeFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_33df2492-fe79-4ef8-952e-d1a7dcc5b693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and big cats, with interactive experiences like giraffe feeding and a splash pad for kids. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for military and families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5f17-70e1-b5ce-bdb5bb07d4ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5f17-70e1-b5ce-bdb5bb07d4ef",
        "storage_key": "property/6767906449165605/019d2709-5f17-70e1-b5ce-bdb5bb07d4ef.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_edd2ccfc-56bb-4e61-bda9-88aa3384d4ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of interactive exhibits, including a planetarium, live shows, and a children's play area. They highlight the educational and engaging experience for all ages, and the spacious layout that prevents overcrowding. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-5ed7-773a-b408-25481ffc55e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5ed7-773a-b408-25481ffc55e1",
        "storage_key": "property/6767906449165605/019d2709-5ed7-773a-b408-25481ffc55e1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-866d-76ed-8199-05221debc502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-866d-76ed-8199-05221debc502",
        "storage_key": "property/6767906449165605/019d2709-866d-76ed-8199-05221debc502.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_27e37898-d82f-414a-a431-f08da76bba4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Frontier City",
      "poi_type": "Entertainment",
      "poi_address": "11501 N I- 35 Service Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "Western-themed amusement park offering thrill, kids' & water rides plus multiple shows & eateries.",
      "poi_long_description": "People say this theme park offers a variety of rides, including thrill rides, water rides, and rides for younger children, as well as live shows. They also highlight the park is clean, the staff is friendly, and the lines are short on weekdays.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-61bb-765a-aaff-27c7946c6783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-61bb-765a-aaff-27c7946c6783",
        "storage_key": "property/6767906449165605/019d2709-61bb-765a-aaff-27c7946c6783.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/frontiercity",
      "poi_directions_map_url": "https://maps.google.com/?cid=7374031908058551867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frontier-city",
      "poi_latitude": "35.5856674",
      "poi_longitude": "-97.4394665",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-478-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzIo0KYYsocRO9Y5evPSVWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_4dcd4400-5dff-47b0-92f7-9f80d36aefbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Dioramas, artifacts, art & more documenting & interpreting the history of the American West.",
      "poi_long_description": "People say this museum offers a vast collection of Western art, artifacts, and exhibits showcasing cowboy, Native American, and rodeo history, as well as a recreated Western town and outdoor exhibits. They highlight the informative and educational experience, and the friendly and knowledgeable staff. They also like the beautiful artwork and the immersive learning opportunities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-62bd-7592-aecf-86f7d99eba61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-62bd-7592-aecf-86f7d99eba61",
        "storage_key": "property/6767906449165605/019d2709-62bd-7592-aecf-86f7d99eba61.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-cowboy--western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-866d-76ed-8199-05221debc502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-866d-76ed-8199-05221debc502",
        "storage_key": "property/6767906449165605/019d2709-866d-76ed-8199-05221debc502.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_142724b7-3f77-4824-9b63-f2ffdd9db32d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of aquatic, aviary, and reptilian exhibits, including stingray feeding, a bird room with parakeets, and a mermaid show. They also highlight the interactive experiences, such as water tables, a pirate ship play area, and a rock climbing wall, as well as the friendly and helpful staff.\n\nOther reviews mention the exhibits can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6399-752d-8a79-0654b37a6845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6399-752d-8a79-0654b37a6845",
        "storage_key": "property/6767906449165605/019d2709-6399-752d-8a79-0654b37a6845.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-477-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_5d0c32f4-3830-49a2-9fb9-96b5a43cfe0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Mitch Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 Marilyn Williams Dr, Edmond, OK 73003, USA",
      "poi_short_description": "Clean sports facility featuring a fitness center and an outdoor track, as well as an indoor pool, disc golf and basketball courts.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment, including cardio and weight machines, as well as amenities like pools, a lazy river, a water slide, and courts for basketball and pickleball. They also highlight the clean facilities, friendly staff, and numerous classes available.\n\nOther reviews mention the equipment can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6556-7242-a8e2-19e41b86488d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6556-7242-a8e2-19e41b86488d",
        "storage_key": "property/6767906449165605/019d2709-6556-7242-a8e2-19e41b86488d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ymcaokc.org/branches/mitch-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15994863836961186949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park-ymca",
      "poi_latitude": "35.6847017",
      "poi_longitude": "-97.5083114",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-330-4016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eeHJvT1sYcRhSTQUOor-d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_175c9aa3-82d4-4bd1-9a74-ea6b144b34fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of services, including cardio/weights, group fitness, swimming, tennis, and pickleball. They also highlight the attentive lifeguards, the well-maintained facilities, and the excellent childcare program.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6653-7397-bb6b-6f8051d8e566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6653-7397-bb6b-6f8051d8e566",
        "storage_key": "property/6767906449165605/019d2709-6653-7397-bb6b-6f8051d8e566.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3ec82f22-acd9-470c-bd32-043bfc08585d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of equipment, including squat racks, free weights, and cardio machines, as well as great group classes and a sauna. \n\nOther reviews mention the gym can be crowded and the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6807-75ea-a20e-bf0df1c8c776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6807-75ea-a20e-bf0df1c8c776",
        "storage_key": "property/6767906449165605/019d2709-6807-75ea-a20e-bf0df1c8c776.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2686fa6d-1dbf-4424-9b76-51c7f0ac6691",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "Some gym goers say this gym has a wide variety of new equipment, a spacious layout, and a great outdoor workout area. \n\nOther reviews mention the gym can be crowded and classes can be difficult to book.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-68a8-77b6-8167-129164c9388e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-68a8-77b6-8167-129164c9388e",
        "storage_key": "property/6767906449165605/019d2709-68a8-77b6-8167-129164c9388e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_adc57035-f1a7-4a5d-af1d-d961faaa032b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers a variety of programs, including gymnastics and ninjastics, and hosts fun events like the M&M Olympics. They highlight the positive and encouraging atmosphere, and the personalized attention provided by the coaches. They also like the staff's dedication, professionalism, and genuine care for each child's progress and well-being.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6adf-700b-97fd-c4addfc320fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6adf-700b-97fd-c4addfc320fc",
        "storage_key": "property/6767906449165605/019d2709-6adf-700b-97fd-c4addfc320fc.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e93508b64e78",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_55312048-191a-482f-b56f-d61bf8c320a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2209 W Edmond Rd, Edmond, OK 73003, USA",
      "poi_short_description": "Laid-back fitness center featuring workout machines plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a good selection of equipment and free weights, and the facility is clean and tidy. They highlight the affordable price and welcoming, non-judgmental atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6bec-74a8-93a6-516204f67ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6bec-74a8-93a6-516204f67ee5",
        "storage_key": "property/6767906449165605/019d2709-6bec-74a8-93a6-516204f67ee5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/edmond-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12798186502624872755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.6543154",
      "poi_longitude": "-97.5129943",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-697-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4H7420esocRM4knAtFKnLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_27db357b-ebfb-4641-8b67-b4210c6c008a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "TB Fit Club | TB Golf | TB Recovery",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of new and modern equipment, including a golf simulator and expanded recovery options, and the staff are helpful and professional.\n\nOther reviews mention the facilities can be poorly maintained and the air conditioning can be inadequate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6d21-726d-8811-5658e091c2d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6d21-726d-8811-5658e091c2d8",
        "storage_key": "property/6767906449165605/019d2709-6d21-726d-8811-5658e091c2d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fit-club--tb-golf--tb-recovery",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_98e50536-1648-47b0-a226-4652d4a3068f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6da5-73d8-9b10-b4ee70d25e3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6da5-73d8-9b10-b4ee70d25e3f",
        "storage_key": "property/6767906449165605/019d2709-6da5-73d8-9b10-b4ee70d25e3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8270-717c-9343-e93508b64e78",
        "storage_key": "property/6767906449165605/019d2709-8270-717c-9343-e93508b64e78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_86565633-72c3-4759-b4db-ac5e713bd81d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Scissors & Scotch",
      "poi_type": "Health and Wellness",
      "poi_address": "13230 Pawnee Dr #202, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Upscale barber shop for beard trims and straight-razor shaves alongside a private lounge and a full bar with whisky. Waxing, manicures and massages are also offered.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://scissorsscotch.com/locations/ok/oklahoma-city/chisholm-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17460232672315201299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissors--scotch",
      "poi_latitude": "35.60419",
      "poi_longitude": "-97.5337642",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-486-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62z3xRocsocRE1cEcRs1T_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_7b545247-d5af-49f6-9e4f-0e8c45b8d09f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "McBride Orthopedic Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9600 Broadway Ext, Oklahoma City, OK 73114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-6fe0-74ba-8133-42cb4a4d1605.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6fe0-74ba-8133-42cb4a4d1605",
        "storage_key": "property/6767906449165605/019d2709-6fe0-74ba-8133-42cb4a4d1605.webp",
        "width": 1280,
        "height": 930
      },
      "poi_business_url": "http://www.mcboh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10772037074811406715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcbride-orthopedic-hospital",
      "poi_latitude": "35.5683383",
      "poi_longitude": "-97.510895",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-486-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8681-73c6-8f25-5ed8ce72680e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8681-73c6-8f25-5ed8ce72680e",
        "storage_key": "property/6767906449165605/019d2709-8681-73c6-8f25-5ed8ce72680e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwn8qDQXsocRe8l4l6X2fZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fb55cdd0-553b-41cb-8b5c-ea984787c4b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "INTEGRIS Health Edmond Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 Integris Pkwy, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-70dc-77ea-98cf-4cb15e88aa74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-70dc-77ea-98cf-4cb15e88aa74",
        "storage_key": "property/6767906449165605/019d2709-70dc-77ea-98cf-4cb15e88aa74.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://integrishealth.org/locations/hospital/integris-health-edmond-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204265952285374783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-edmond-hospital",
      "poi_latitude": "35.6444304",
      "poi_longitude": "-97.4183639",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-657-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8681-73c6-8f25-5ed8ce72680e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8681-73c6-8f25-5ed8ce72680e",
        "storage_key": "property/6767906449165605/019d2709-8681-73c6-8f25-5ed8ce72680e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJufe603CjdYgRPzn5VoWMfZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1b90b6e4-82b2-49c2-9913-7f9e6c9408c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "E.C. Hafer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1034 S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Sizable park with a volleyball court, small fishing pond, trails & playgrounds, plus grassy areas.",
      "poi_long_description": "People say this park offers a variety of trails, playgrounds, and a beautiful lake, as well as picnic tables, pavilions, and a duck pond. They highlight the park's natural beauty, with lots of trees and wildlife, and the clean, well-maintained facilities, including restrooms with changing stations. They also like the peaceful and relaxing vibe, making it a great place for families, walks, and connecting with nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-7200-7144-a423-2d10c42949b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7200-7144-a423-2d10c42949b3",
        "storage_key": "property/6767906449165605/019d2709-7200-7144-a423-2d10c42949b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://edmondok.com/facilities/Facility/Details/9",
      "poi_directions_map_url": "https://maps.google.com/?cid=2633511566572246196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ec-hafer-park",
      "poi_latitude": "35.6428821",
      "poi_longitude": "-97.4551926",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-359-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8716-700e-8f78-e8f816eccf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8716-700e-8f78-e8f816eccf9a",
        "storage_key": "property/6767906449165605/019d2709-8716-700e-8f78-e8f816eccf9a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOa4APJ4fsocRtNRrHdEcjCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fc79edf3-c019-48b3-8a71-51784c74ad39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Kickingbird Golf",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 E Danforth Rd, Edmond, OK 73034, USA",
      "poi_short_description": "Well-kept course featuring bunkers, a practice area, a driving range and a pro shop.",
      "poi_long_description": "People say this golf course offers a well-maintained, fun, and enjoyable course with fast greens and a challenging layout. They also highlight the modern amenities, state-of-the-art equipment, and excellent practice facilities, including a Trackman range, three pitching greens, and an enormous practice green.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-7292-7448-8d78-c5e51be17f67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7292-7448-8d78-c5e51be17f67",
        "storage_key": "property/6767906449165605/019d2709-7292-7448-8d78-c5e51be17f67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kickingbirdgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575429422620550350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kickingbird-golf",
      "poi_latitude": "35.6659317",
      "poi_longitude": "-97.4576492",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-341-5350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8a1b-72e8-bce3-ea394318f542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a1b-72e8-bce3-ea394318f542",
        "storage_key": "property/6767906449165605/019d2709-8a1b-72e8-bce3-ea394318f542.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxVdOesfsocRziR3p4kKJ9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5fc34eb6-76ad-4399-80f0-f070d65519a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "People say this private golf course offers a great golf course, restaurants, and facilities. They also highlight the amazing staff, beautiful scenery, and good vibes.\n\nOther reviews mention the course conditions can be unchanged.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-7517-7449-8992-9410cc408a12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7517-7449-8992-9410cc408a12",
        "storage_key": "property/6767906449165605/019d2709-7517-7449-8992-9410cc408a12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8a1b-72e8-bce3-ea394318f542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a1b-72e8-bce3-ea394318f542",
        "storage_key": "property/6767906449165605/019d2709-8a1b-72e8-bce3-ea394318f542.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7634faca-c1cf-4c23-b9de-d8409c25a22e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Mitch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1501 W Covell Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a well-maintained, paved walking trail with scenic views and opportunities for various activities like walking, jogging, and dog walking. They highlight the peaceful and refreshing atmosphere, suitable for families and people of all fitness levels. They also like the nearby YMCA facility, which provides additional fitness options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-75be-761d-80ff-69da84a4a1c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-75be-761d-80ff-69da84a4a1c7",
        "storage_key": "property/6767906449165605/019d2709-75be-761d-80ff-69da84a4a1c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edmondok.gov/facilities/facility/details/Mitch-Park-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=1740714302256427325&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park",
      "poi_latitude": "35.6826377",
      "poi_longitude": "-97.5065914",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8716-700e-8f78-e8f816eccf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8716-700e-8f78-e8f816eccf9a",
        "storage_key": "property/6767906449165605/019d2709-8716-700e-8f78-e8f816eccf9a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfU7CegD1sYcRPbFvaW9CKBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_84b01b14-d372-4c68-8509-622c0b06a18d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "The Golf Club of Edmond",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4001 Fairfax Dr, Edmond, OK 73034, USA",
      "poi_short_description": "Public golf course with a driving range offering tournaments, plus a food option.",
      "poi_long_description": "Golfers say this public golf course offers excellent course conditions, a great selection of merchandise, and tasty food. They also highlight the friendly and helpful staff, and the overall value for money.\n\nSome reviews mention the course can be challenging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-76bc-750b-939a-15d613c7b611.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-76bc-750b-939a-15d613c7b611",
        "storage_key": "property/6767906449165605/019d2709-76bc-750b-939a-15d613c7b611.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.golfedmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15577750115198172692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-golf-club-of-edmond",
      "poi_latitude": "35.6849669",
      "poi_longitude": "-97.4296555",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-359-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-8a1b-72e8-bce3-ea394318f542.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-8a1b-72e8-bce3-ea394318f542",
        "storage_key": "property/6767906449165605/019d2709-8a1b-72e8-bce3-ea394318f542.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWS32wggsocRFP4vADJJL9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ddaa5ec7-d8be-4a5b-ad18-e75ead985526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-792a-73dd-8495-f89d6763dc8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-792a-73dd-8495-f89d6763dc8b",
        "storage_key": "property/6767906449165605/019d2709-792a-73dd-8495-f89d6763dc8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b209e12d-cae2-4b8c-96d4-08b8afd00207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Chesapeake Energy Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-7ae1-738f-8f16-02a70583d34b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7ae1-738f-8f16-02a70583d34b",
        "storage_key": "property/6767906449165605/019d2709-7ae1-738f-8f16-02a70583d34b.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.expandenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999976576566005612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chesapeake-energy-corporation",
      "poi_latitude": "35.5346273",
      "poi_longitude": "-97.5289016",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-848-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cjlSYasocRbI8Z7IDFgjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6ec3531b-4768-4073-bc97-1a8bf6bb5368",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "CFS Brands",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4711 E Hefner Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-7a5a-773f-aab5-24a37867acdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7a5a-773f-aab5-24a37867acdd",
        "storage_key": "property/6767906449165605/019d2709-7a5a-773f-aab5-24a37867acdd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cfsbrands.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6460468295741084389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cfs-brands",
      "poi_latitude": "35.5808644",
      "poi_longitude": "-97.435523",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-654-8210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZmxMAoisocR5RJSmq8xqFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7f46cc86-0e24-4759-914d-948b8b5599e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Love's Corporate Office Building South",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10401 N Pennsylvania Ave, The Village, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-7c24-726d-bf2c-8b2d867842aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7c24-726d-bf2c-8b2d867842aa",
        "storage_key": "property/6767906449165605/019d2709-7c24-726d-bf2c-8b2d867842aa.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14437476488466279899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate-office-building-south",
      "poi_latitude": "35.5768571",
      "poi_longitude": "-97.5501262",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5qho4IbsocR2y0WjF84XMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b220b3ce-4b83-48fb-8768-1c26e7f5c34b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-7e29-7788-b0ec-38016dace1c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7e29-7788-b0ec-38016dace1c7",
        "storage_key": "property/6767906449165605/019d2709-7e29-7788-b0ec-38016dace1c7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-862a-70bf-a38a-f2208f4f7b02",
        "storage_key": "property/6767906449165605/019d2709-862a-70bf-a38a-f2208f4f7b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_551b9947-b04b-4c7c-94f2-30de3d76b820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Orvis Risner Elementary School",
      "poi_type": "Education",
      "poi_address": "2801 S Rankin St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://orvisrisner.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7839498494672854300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "orvis-risner-elementary-school",
      "poi_latitude": "35.62797190000001",
      "poi_longitude": "-97.4754065",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-340-2984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d20-716a-9eba-1b720928cf76",
        "storage_key": "property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4WH-RhsfsocRHF0vcFh-y2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9abbc762-5909-415a-8661-1808c4167e0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Cimarron Middle School",
      "poi_type": "Education",
      "poi_address": "3701 S Bryant Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-34fd-732f-ba2e-900e8c969714.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-34fd-732f-ba2e-900e8c969714",
        "storage_key": "property/6767906449165605/019d7912-34fd-732f-ba2e-900e8c969714.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cimarron.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14977112001491695191&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cimarron-middle-school",
      "poi_latitude": "35.6193426",
      "poi_longitude": "-97.4618711",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-340-2935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d20-716a-9eba-1b720928cf76",
        "storage_key": "property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtzcgRhUfsocRV_YmYgNk2c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_04f84cd6-b0b9-4498-9467-e0049f730ebe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Edmond Memorial High School",
      "poi_type": "Education",
      "poi_address": "1000 E 15th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-35c6-7763-8911-fea60d814302.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-35c6-7763-8911-fea60d814302",
        "storage_key": "property/6767906449165605/019d7912-35c6-7763-8911-fea60d814302.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://memorial.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3181141735260527642&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-memorial-high-school",
      "poi_latitude": "35.6372634",
      "poi_longitude": "-97.468602",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-340-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d20-716a-9eba-1b720928cf76",
        "storage_key": "property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq7JPsAkfsocRGpxfxo2vJSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d69f7196-ab09-4c7a-8f4b-727af10770e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Mercy School Institute",
      "poi_type": "Education",
      "poi_address": "14001 N Harvey Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-3399-771e-941a-b4ba8eac0ad1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3399-771e-941a-b4ba8eac0ad1",
        "storage_key": "property/6767906449165605/019d7912-3399-771e-941a-b4ba8eac0ad1.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "http://www.mercyschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11702466736219190867&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mercy-school-institute",
      "poi_latitude": "35.6127046",
      "poi_longitude": "-97.5190585",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-748-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d20-716a-9eba-1b720928cf76",
        "storage_key": "property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEZOm26MesocRU3YriH6DZ6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9a1d7412-8aa3-46e1-ae32-49cf22dd719d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Heritage Hall",
      "poi_type": "Education",
      "poi_address": "1800 NW 122nd St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-352a-7439-8569-40c095e65b6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-352a-7439-8569-40c095e65b6e",
        "storage_key": "property/6767906449165605/019d7912-352a-7439-8569-40c095e65b6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.heritagehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233749162249664118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-hall",
      "poi_latitude": "35.591122",
      "poi_longitude": "-97.542737",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-749-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d20-716a-9eba-1b720928cf76",
        "storage_key": "property/6767906449165605/019cfb41-1d20-716a-9eba-1b720928cf76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_UYSwgcsocRdrYreolwY2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_07471df9-d71b-48f4-9c64-b5edfd8b2c1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Saki Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "13520 N Eastern Ave Suite B, Oklahoma City, OK 73131, USA",
      "poi_short_description": "Traditional Japanese dishes & an extensive menu of sushi rolls & specials with modern Asian decor.",
      "poi_long_description": "People say this sushi restaurant offers delicious and unique sushi rolls, as well as other Japanese dishes like katsu and soba noodles. They highlight the reasonable prices and generous portions. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-4001-7398-9c3d-0b7772ed8788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4001-7398-9c3d-0b7772ed8788",
        "storage_key": "property/6767906449165605/019d7912-4001-7398-9c3d-0b7772ed8788.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sakiichibansushibar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12182626669020303329&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "saki-sushi-bar",
      "poi_latitude": "35.6080871",
      "poi_longitude": "-97.4776527",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-607-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d1a-71c9-9387-3a169640d1c0",
        "storage_key": "property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1BM7lgfsocR4c8nvmhiEak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_3577ac9b-7920-4c32-b137-04cd33ac906a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Gabriella's Italian Grill & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3601 S Broadway Ste 600, Edmond, OK 73013, USA",
      "poi_short_description": "Chef-owned eatery crafting refined homestyle Italian cuisine in a relaxed, family-friendly ambiance.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, pizza, and other Italian dishes. They also highlight the authentic ingredients, family atmosphere, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-4975-72ee-a1fd-be381fc0d74e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4975-72ee-a1fd-be381fc0d74e",
        "storage_key": "property/6767906449165605/019d7912-4975-72ee-a1fd-be381fc0d74e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gabriellasokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6000322265861139267&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gabriella-s-italian-grill-pizzeria",
      "poi_latitude": "35.619277",
      "poi_longitude": "-97.4906807",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-478-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d1a-71c9-9387-3a169640d1c0",
        "storage_key": "property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_PxPrEZsocRQyuFSk9tRVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_86e5c910-0a8c-4ab8-82d4-a490a1c08558",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "No Cow Bakery and Cafe",
      "poi_type": "Restaurants",
      "poi_address": "23 W 1st St suite 20, Edmond, OK 73003, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this bakery offers delicious gluten-free, dairy-free, and nut-free baked goods, including pretzels, cinnamon rolls, and cakes. They highlight the fair prices and the welcoming, friendly atmosphere. They also like the dedicated staff and the management's commitment to providing allergy-friendly treats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-4ff9-70fe-be70-7c42c6cae710.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4ff9-70fe-be70-7c42c6cae710",
        "storage_key": "property/6767906449165605/019d7912-4ff9-70fe-be70-7c42c6cae710.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nocowbakeryandcafe.org/?fbclid=IwY2xjawNA6MdleHRuA2FlbQIxMABicmlkETF4QWxrZzRzMzZsaGZpSENoAR6lKVfckWihwt5l2Hoot3QYO5x5Wugv0-RHKa2uZQWY5JP8JMC1MbNLBOqcJA_aem_y8KcFjsyoxfBbuEIKlMy_Q",
      "poi_directions_map_url": "https://maps.google.com/?cid=16866262741604250052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "no-cow-bakery-and-cafe",
      "poi_latitude": "35.6546359",
      "poi_longitude": "-97.4824913",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 572-239-8566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d1a-71c9-9387-3a169640d1c0",
        "storage_key": "property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVRXcQAfsocRxDG6KZoAEeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_3fcdbca1-f42d-46ed-96c4-b667b75e8dec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Uncle Julio's Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1344 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this restaurant serves delicious Mexican food, including bacon-wrapped shrimp, fajitas, and enchiladas. They also highlight the fun atmosphere, the delicious chocolate piñata, and the attentive service.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-5191-750c-873d-08a1418a2793.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5191-750c-873d-08a1418a2793",
        "storage_key": "property/6767906449165605/019d7912-5191-750c-873d-08a1418a2793.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6592367220314025478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-oklahoma-city",
      "poi_latitude": "35.6075896",
      "poi_longitude": "-97.5374138",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-486-0720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d1a-71c9-9387-3a169640d1c0",
        "storage_key": "property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4TdSPodsocRBi6_Gw_LfFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e2b8056a-d0e6-461b-ae70-a2f1dff38c14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Brent's Cajun Seafood And Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "3005 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "New Orleans–themed bar/eatery offering Cajun seafood staples, plus weekend brunch & outdoor seating.",
      "poi_long_description": "People say this seafood restaurant serves delicious Cajun food, including charbroiled oysters, crawfish, and gumbo. They also highlight the generous portions, reasonable prices, and excellent service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-4ffd-74a9-878e-0a5145c35948.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4ffd-74a9-878e-0a5145c35948",
        "storage_key": "property/6767906449165605/019d7912-4ffd-74a9-878e-0a5145c35948.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://www.brentscajunfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8187144985205302848&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brent-s-cajun-seafood-and-oyster-bar",
      "poi_latitude": "35.6253831",
      "poi_longitude": "-97.486042",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-285-0911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d1a-71c9-9387-3a169640d1c0",
        "storage_key": "property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYpsneMesocRQGbIl_yUnnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_225e1fcb-a130-42ca-a393-e006e1c86f0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3409 S Broadway #400, Edmond, OK 73013, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious croissants, salads, and shrimp cargot. They highlight the fresh ingredients, generous portions, and upscale atmosphere. They also like the attentive and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-5ac8-72cd-8df8-de3fb03511aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5ac8-72cd-8df8-de3fb03511aa",
        "storage_key": "property/6767906449165605/019d7912-5ac8-72cd-8df8-de3fb03511aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-edmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=294390371871737234&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "35.62256929999999",
      "poi_longitude": "-97.4880033",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-478-4949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d1a-71c9-9387-3a169640d1c0",
        "storage_key": "property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyU9nnuYesocRksW1xHviFQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_22013814-7f24-4877-aba6-a9855d9bfd8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Fuzzy's Taco Shop",
      "poi_type": "Restaurants",
      "poi_address": "1462 S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Modern counter-service chain serving Baja-style tacos & other Mexican eats, plus beer & margaritas.",
      "poi_long_description": "People say this taco restaurant serves delicious tacos, nachos, and fried avocado tacos. They highlight the reasonable prices, Baja-style menu, and low-priced margaritas. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-5ed0-74b0-8f81-281fc052d277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5ed0-74b0-8f81-281fc052d277",
        "storage_key": "property/6767906449165605/019d7912-5ed0-74b0-8f81-281fc052d277.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://fuzzystacoshop.com/locations/oklahoma/edmond/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=30804",
      "poi_directions_map_url": "https://maps.google.com/?cid=6140913212884146510&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fuzzy-s-taco-shop",
      "poi_latitude": "35.6392685",
      "poi_longitude": "-97.4586942",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-562-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d1a-71c9-9387-3a169640d1c0",
        "storage_key": "property/6767906449165605/019cfb41-1d1a-71c9-9387-3a169640d1c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3R2yAofsocRTll2-gfoOFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_636b1fb1-c78e-4615-94c5-dc9d01854b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 E 2nd St, Edmond, OK 73034, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-659c-7346-bd3b-125fd3e58222.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-659c-7346-bd3b-125fd3e58222",
        "storage_key": "property/6767906449165605/019d7912-659c-7346-bd3b-125fd3e58222.webp",
        "width": 963,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/edmond/1398",
      "poi_directions_map_url": "https://maps.google.com/?cid=13278392628590237994&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.64976130000001",
      "poi_longitude": "-97.4639992",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-844-5072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuXZhQqMfsocRKllJZ75TRrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e4d7fd35-91a7-4608-bd1b-4f89a93460e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "13200 N Western Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including fresh produce, easy-cook meals, and clothing. They also highlight the great deals, awesome prices, and the availability of unique items.\n\nOther reviews mention the checkout process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-6cea-72eb-8123-1a12f6f034b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6cea-72eb-8123-1a12f6f034b0",
        "storage_key": "property/6767906449165605/019d7912-6cea-72eb-8123-1a12f6f034b0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/oklahoma-city-OK-1350.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14122877494864452912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "35.6041749",
      "poi_longitude": "-97.5303089",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-832-5102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaye3fSUdsocRMB3BX0GK_sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_3542c600-27b5-4e23-b260-dd123b319988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "People say this sporting goods store offers a good selection of athletic gear, shoes, and outdoor equipment. They also highlight the helpful and friendly staff, and the clean and well-organized store.\n\nOther reviews mention items can be out of stock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-70fa-7155-b892-195e6f7b089b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-70fa-7155-b892-195e6f7b089b",
        "storage_key": "property/6767906449165605/019d7912-70fa-7155-b892-195e6f7b089b.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/edmond/store-0085",
      "poi_directions_map_url": "https://maps.google.com/?cid=6115064585732323518&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "35.6302308",
      "poi_longitude": "-97.4856243",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-715-4530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCZltzvwesocRvngle9cS3VQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_933e43a3-b489-4e56-a97d-cb25eb4e61fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "22 E 33rd St, Edmond, OK 73013, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "People say this department store offers a wide selection of home goods, including furniture, decor, and kitchenware. They also highlight the great bargains and deals, and the friendly and helpful staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-775c-7593-bdfb-a2b186079aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-775c-7593-bdfb-a2b186079aa8",
        "storage_key": "property/6767906449165605/019d7912-775c-7593-bdfb-a2b186079aa8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11354561985580030267&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "35.6221876",
      "poi_longitude": "-97.484125",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-330-5544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfQl6wzYfsocRO9mmgveBk50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_630b5da1-e5d0-4fec-8265-219ddb0e833d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1225 W I- 35 Frontage Rd, Edmond, OK 73034, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this department store offers a wide selection of groceries and household items, and the staff is friendly and helpful.\n\nOther reviews mention the prices can be high and the self-checkout can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-76ad-72a3-9750-6e16c05d0be1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-76ad-72a3-9750-6e16c05d0be1",
        "storage_key": "property/6767906449165605/019d7912-76ad-72a3-9750-6e16c05d0be1.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/389-edmond-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=337826658929029544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.6400257",
      "poi_longitude": "-97.4291784",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-348-8005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJcZlitIhsocRqDEfcY4zsAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_29785048-abc5-4f92-ba47-fefb783fec8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Vintage Stock",
      "poi_type": "Shopping & Retail",
      "poi_address": "30 E 33rd St, Edmond, OK 73013, USA",
      "poi_short_description": "Home-entertainment chain that buys & sells movies, music & games, books, comics, toys & memorabilia.",
      "poi_long_description": "People say this DVD store offers a wide selection of games, DVDs, trading cards, and anime figures, with helpful and friendly staff who are knowledgeable about the products. They also highlight the diverse range of items, including retro consoles and games, making it a great place to find obscure or vintage items.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-7ade-73f3-a067-51f2a1eb9b23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7ade-73f3-a067-51f2a1eb9b23",
        "storage_key": "property/6767906449165605/019d7912-7ade-73f3-a067-51f2a1eb9b23.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8481775558942578946&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vintage-stock",
      "poi_latitude": "35.621962",
      "poi_longitude": "-97.483585",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-341-7731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d30-7108-997a-a99e1f7e31ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d30-7108-997a-a99e1f7e31ec",
        "storage_key": "property/6767906449165605/019cfb41-1d30-7108-997a-a99e1f7e31ec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3bGwuMesocRAtlct-5RtXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_11f685cb-bf5a-44d4-bd4a-0d66cc448783",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Cabela's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Retail mainstay stocking a huge inventory of hunting, fishing & camping supplies, plus boats & ATVs.",
      "poi_long_description": "People say this sporting goods store offers a wide variety of products for hunting, fishing, and other outdoor activities. They also highlight the helpful and friendly staff, and the convenient overnight RV parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-8353-74d1-98ea-65a762371d6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8353-74d1-98ea-65a762371d6a",
        "storage_key": "property/6767906449165605/019d7912-8353-74d1-98ea-65a762371d6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.cabelas.com/us/ok/oklahoma-city/1200-w-memorial-rd.html?y_source=1_Mzk4Njc3MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3642026274716462212&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cabela-s",
      "poi_latitude": "35.605703",
      "poi_longitude": "-97.5343856",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-546-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVHShxkcsocRhCwdv5kTizI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_6461ceb0-93ad-4735-a3fc-b7cd0128a322",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Kendra Scott",
      "poi_type": "Shopping & Retail",
      "poi_address": "1452 S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Branch of the designer's jewelry boutique known for customizable jewelry in a range of colors.",
      "poi_long_description": "Branch of the designer's jewelry boutique known for customizable jewelry in a range of colors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-82a0-7725-ac3f-b0209d0809f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-82a0-7725-ac3f-b0209d0809f8",
        "storage_key": "property/6767906449165605/019d7912-82a0-7725-ac3f-b0209d0809f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kendrascott.com/stores/ok/edmond/265096",
      "poi_directions_map_url": "https://maps.google.com/?cid=13095259644316108878&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kendra-scott",
      "poi_latitude": "35.639533",
      "poi_longitude": "-97.458759",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-562-5476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTcW5magfsocRTkj4zEO1u7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "jewelry_store"
    },
    {
      "id": "custom_fae3c63f-0587-4831-935e-4c2881880a90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "LOFT",
      "poi_type": "Shopping & Retail",
      "poi_address": "1494 S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Women's apparel brand known for its careerwear, dresses & separates in contemporary styles.",
      "poi_long_description": "Women's apparel brand known for its careerwear, dresses & separates in contemporary styles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-8a53-776e-9b65-a13c3d77de94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8a53-776e-9b65-a13c3d77de94",
        "storage_key": "property/6767906449165605/019d7912-8a53-776e-9b65-a13c3d77de94.webp",
        "width": 314,
        "height": 366
      },
      "poi_business_url": "https://www.loft.com/store/ok/edmond/1494-south-bryant-avenue?y_source=1_MTY0MjE3Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16065546207404905723&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "loft",
      "poi_latitude": "35.6396591",
      "poi_longitude": "-97.4596605",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-341-5572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj8lWrJkgsocR-1T-HihJ9N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "womens_clothing_store"
    },
    {
      "id": "custom_063f9afb-49a2-4419-8ad6-e3284ae514cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Shoppes On Broadway",
      "poi_type": "Shopping & Retail",
      "poi_address": "3248 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Shopping mall featuring Hobby Lobby, as well as other retailers and fast-food restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-8b26-7303-a029-d346ca6b2814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8b26-7303-a029-d346ca6b2814",
        "storage_key": "property/6767906449165605/019d7912-8b26-7303-a029-d346ca6b2814.webp",
        "width": 656,
        "height": 874
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5707196026152173320&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shoppes-on-broadway",
      "poi_latitude": "35.624096",
      "poi_longitude": "-97.4848489",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-562-3521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx96blOMesocRCD9SOowINE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e6590b59-0d97-4195-beb3-572c8c8e0fe6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Bryant Square Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Outlet strip mall offering a variety of stores, including T-Mobile.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-966e-7161-9a0a-7d753222dcfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-966e-7161-9a0a-7d753222dcfa",
        "storage_key": "property/6767906449165605/019d7912-966e-7161-9a0a-7d753222dcfa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3178030218710411092&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bryant-square-shopping-center",
      "poi_latitude": "35.6497984",
      "poi_longitude": "-97.4579354",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d36-7093-94f7-4618de09c18d",
        "storage_key": "property/6767906449165605/019cfb41-1d36-7093-94f7-4618de09c18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhWfGQr0fsocRVOewX6WhGiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7e1bb400-2964-4416-a37d-84b838aebd08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Breakout Games",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd #227, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Team-building escape room venue featuring puzzle-filled scenarios and themed challenges.",
      "poi_long_description": "People say this escape room center offers a variety of fun and challenging rooms, including Runaway Train, Kidnapping, and Museum Heist. They highlight the puzzles are varied and have a high level of difficulty, and the rooms are well-decorated and interactive. They also like that the games are designed for private groups, allowing friends and family to play together.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-948d-7353-a5bf-158ec852e4a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-948d-7353-a5bf-158ec852e4a9",
        "storage_key": "property/6767906449165605/019d7912-948d-7353-a5bf-158ec852e4a9.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.breakoutgames.com/oklahoma-city?utm_source=google&utm_medium=organic&utm_campaign=gmb-oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=1439416862903744307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "breakout-games",
      "poi_latitude": "35.612875",
      "poi_longitude": "-97.557172",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-731-9192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d30-7108-997a-a99e1f7e31ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d30-7108-997a-a99e1f7e31ec",
        "storage_key": "property/6767906449165605/019cfb41-1d30-7108-997a-a99e1f7e31ec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8jzfGccsocRM7cVrQLW-RM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_0cd2d10d-99f3-468c-9d23-882992b8946c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Park with trails through woods & grassland, plus amenities including a playground & nature center.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-973d-766d-a5cf-f364db38fcff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-973d-766d-a5cf-f364db38fcff",
        "storage_key": "property/6767906449165605/019d7912-973d-766d-a5cf-f364db38fcff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d21-7759-9b19-07e155909cae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d21-7759-9b19-07e155909cae",
        "storage_key": "property/6767906449165605/019cfb41-1d21-7759-9b19-07e155909cae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_600429aa-5eaa-4d45-a782-3dfa797246cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Oklahoma City National Memorial & Museum",
      "poi_type": "Entertainment",
      "poi_address": "620 N Harvey Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A garden, pool & sculptural memorial commemorating victims of the 1995 Murrah Building bombing.",
      "poi_long_description": "Visitors say this memorial and museum offers a moving experience, honoring the lives lost in the 1995 Oklahoma City bombing. They also highlight the peaceful and serene atmosphere, with many finding it a place for quiet reflection and remembrance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-989f-71ab-9ce2-b343f77db521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-989f-71ab-9ce2-b343f77db521",
        "storage_key": "property/6767906449165605/019d7912-989f-71ab-9ce2-b343f77db521.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://memorialmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635276338053722639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-national-memorial-museum",
      "poi_latitude": "35.4731496",
      "poi_longitude": "-97.5170593",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-235-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d21-7759-9b19-0977e06137f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d21-7759-9b19-0977e06137f9",
        "storage_key": "property/6767906449165605/019cfb41-1d21-7759-9b19-0977e06137f9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq81FLi4XsocRDzJ3TUXPU0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2a32fb77-7c46-4bf4-b224-225f45d3cc9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A 15-acre facility with formal gardens, a tropical conservatory, a dog park & horticultural classes.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019d7912-9f65-71ca-a234-b87298472b89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9f65-71ca-a234-b87298472b89",
        "storage_key": "property/6767906449165605/019d7912-9f65-71ca-a234-b87298472b89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-1d30-7108-997a-a99e1f7e31ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb41-1d30-7108-997a-a99e1f7e31ec",
        "storage_key": "property/6767906449165605/019cfb41-1d30-7108-997a-a99e1f7e31ec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d0bd9cec6065f583af4ec5b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_826ac5c3c8a131f82758f736",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1be7e8a594f97bf65674f286",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_07432719ae2248e5e17d709e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_fdd899152f644460e8bc72a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a473fc9352b631fac852811e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_792c90e0-d520-4fe8-a33d-7d89b8000fc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "rating": "5.0",
      "name": "Jonathan Watson",
      "text": "I just moved here a little over a week ago and it has been fantastic. The apartments are quiet and the pool is nice. The staff are helpful and friendly and made move in a breeze!",
      "date": "2025-08-14",
      "title": ""
    },
    {
      "id": "custom_ee771894-66e4-4b39-961d-330d84024b40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "rating": "5.0",
      "name": "Dawson Cary",
      "text": "Move in process was great! OG+E took their time getting my utilities information back to me, and everyone was super understanding and supportive of that! Jasmine helped me from the moment I walked into the doors to tour, and she was the one who handed me my keys.\n\nWhen I got there there was a smoke alarm chirping. So I made a maintenance request that night and the next morning before noon the got back to me and fixed the issue! Love the quick turn around time.",
      "date": "2025-09-25",
      "title": ""
    },
    {
      "id": "custom_1cb6bae8-ccb1-4d22-803c-037178dff2a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "rating": "5.0",
      "name": "Pamela Hankins",
      "text": "From our first visit I wanted to be at Fountain Lake.  The grounds and apartments are well kept, and the staff was very helpful.  We had to wait a little while for availability on the ground floor, but we were notified when an apartment became available. We love our apartment and are very happy we made the move!",
      "date": "2025-11-19",
      "title": ""
    },
    {
      "id": "custom_ad8e809d-5922-482d-bd31-b9d11dbc89fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "rating": "5.0",
      "name": "Elise Hancock",
      "text": "Honestly I love it here. The area is relatively quiet and the grounds are always kept very well. The apartments are spacious and very nice even the basic level apartments. Neighbors are friendly or often keep to themselves. The staff is amazing! Any problems you have you can either email them or talk with maintenance and it’ll get done within a day or two! They’re very caring here and understanding!",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ec53d475-b133-45c8-bc6c-d8ea95994896",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-8661-7102-a9ec-a85df34be67a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of an apartment complex pool and buildings",
        "public_id": "019cfb41-8661-7102-a9ec-a85df34be67a",
        "storage_key": "property/6767906449165605/019cfb41-8661-7102-a9ec-a85df34be67a.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fountain Lake Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d6afd267dbd0c25989089&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-33db-707b-95fa-3079a0a64c82",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "fountain-lake",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605"
    },
    {
      "lead_collector_id": "019cf79e-3455-72ef-a320-cc22d88c9bd5",
      "lead_source": "LANDING_PAGE",
      "name": "fountain-lake",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "generator",
      "page_item_url": "fountain-lake-apartments-with-pool-edmond-ok",
      "search_query": "apartments with pool in Edmond OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Edmond, OK",
      "h2_subtitle": "Discover spacious apartments with pool access in Edmond, OK. Enjoy resort-style living at Fountain Lake today.",
      "page_copy": "Welcome to Fountain Lake, where you'll find premium apartments with pool access in Edmond, OK. Our community offers spacious one- and two-bedroom floor plans designed with comfort and style in mind. Dive into luxury with our resort-style pool, ideal for relaxing after a long day. \n\nLocated conveniently close to I-35, Fountain Lake combines exceptional amenities like a fitness center and tranquil courtyard with the convenience of city living. Enjoy the spacious interiors featuring walk-in closets, pantry, and ample storage. Join us today and experience the perfect blend of comfort and convenience in Edmond, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-daf1-73a3-b015-81aec27c1aaa",
        "storage_key": "property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Edmond, OK",
      "seo_description": "Explore Fountain Lake—your destination for apartments with pool in Edmond, OK. Resort-style amenities await. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-73013-fountain-lake",
      "search_query": "fitness center apartments near 73013",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near 73013",
      "h2_subtitle": "Explore apartments with a fitness center near 73013. Fitness-focused living is available at Fountain Lake in Edmond.",
      "page_copy": "Fountain Lake is your go-to destination for fitness center apartments near 73013. Located in Edmond, our community offers exceptional on-site fitness facilities, perfect for residents leading an active lifestyle. Feel energized as you work out just steps away from your front door.\n\nChoose from our spacious one- and two-bedroom floor plans, complemented by resort-style amenities. Nestled close to major routes like I-35, Fountain Lake not only provides easy access but also features luxurious amenities including walk-in closets, a serene courtyard, and a sparkling swimming pool. Embrace a balanced lifestyle at your new home in Fountain Lake.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-daf1-73a3-b015-81aec27c1aaa",
        "storage_key": "property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near 73013",
      "seo_description": "Find fitness center apartments near 73013 at Fountain Lake. Enjoy resort-style living with excellent amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "generator",
      "page_item_url": "gourmet-kitchen-apartments-edmond-ok-fountain-lake",
      "search_query": "gourmet kitchen apartments Edmond Oklahoma",
      "category": "Amenity",
      "h1_title": "Gourmet Kitchen Apartments in Edmond, OK",
      "h2_subtitle": "Discover gourmet kitchen apartments in Edmond, Oklahoma. Experience culinary excellence at Fountain Lake.",
      "page_copy": "Welcome to Fountain Lake, where our gourmet kitchen apartments in Edmond, Oklahoma, elevate your living experience. These spacious one- and two-bedroom homes are perfect for food enthusiasts who love a well-appointed kitchen with plenty of prep space.\n\nNestled conveniently near I-35, Fountain Lake combines style and functionality. Beyond gourmet kitchens, enjoy amenities like a refreshing pool, fitness center, and tranquil courtyards. Ample storage, including walk-in closets and a pantry, offers added convenience. Experience the perfect place for both cooking and relaxation in Edmond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-daf1-73a3-b015-81aec27c1aaa",
        "storage_key": "property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gourmet Kitchen Apartments in Edmond, OK",
      "seo_description": "Find gourmet kitchen apartments in Edmond, OK at Fountain Lake. Enjoy spacious layouts and resort-style amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "generator",
      "page_item_url": "spacious-closets-apartments-edmond-fountain-lake",
      "search_query": "spacious closets apartments Edmond",
      "category": "Amenity",
      "h1_title": "Spacious Closets Apartments in Edmond",
      "h2_subtitle": "Explore spacious closets apartments in Edmond. Enhance your living space at Fountain Lake.",
      "page_copy": "At Fountain Lake, discover apartments featuring spacious closets in Edmond. Our community caters to those who need ample storage, with generous walk-in closets available in every unit. Perfectly designed for your belongings, these closets make organization a breeze.\n\nFountain Lake offers more than just roomy interiors; enjoy our resort-style amenities such as a swimming pool, fitness center, and beautiful courtyards. Located mere minutes from I-35, this vibrant community ensures both convenience and luxury in one setting. Find your ideal home with spacious closets and much more at Fountain Lake today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-daf1-73a3-b015-81aec27c1aaa",
        "storage_key": "property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Closets Apartments in Edmond",
      "seo_description": "Discover spacious closets apartments in Edmond at Fountain Lake. Enjoy generous storage and resort-style living. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "generator",
      "page_item_url": "fountain-lake-resort-style-living-edmond",
      "search_query": "Fountain Lake resort-style living Edmond",
      "category": "Amenity",
      "h1_title": "Fountain Lake Resort-Style Living Edmond",
      "h2_subtitle": "Experience resort-style living at Fountain Lake in Edmond. Enjoy luxury and comfort combined.",
      "page_copy": "Fountain Lake in Edmond offers a premier resort-style living experience. Our beautifully designed community showcases luxurious amenities such as a sparkling pool, well-equipped fitness center, and tranquil courtyard, all of which create a relaxing and upscale environment for residents.\n\nChoose from spacious one- and two-bedroom floor plans, each featuring walk-in closets and ample storage. Positioned conveniently near I-35, Fountain Lake provides easy access to Edmond and beyond. Embrace a lifestyle where comfort and elegance meet, within a community that caters to all your needs with charm and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-daf1-73a3-b015-81aec27c1aaa",
        "storage_key": "property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fountain Lake Resort-Style Living Edmond",
      "seo_description": "Fountain Lake in Edmond offers resort-style living with luxury amenities and spacious floor plans. Discover the ultimate comfort and convenience today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-edmond-ok-fountain-lake",
      "search_query": "one bedroom apartments in Edmond OK",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Edmond, OK",
      "h2_subtitle": "Discover the perfect one bedroom apartments in Edmond, OK at Fountain Lake. Embrace comfort and style.",
      "page_copy": "Fountain Lake offers inviting one bedroom apartments in Edmond, OK that flawlessly blend comfort with modern design. Each unit features spacious layouts, walk-in closets, and a pantry, creating a welcoming home that caters to your lifestyle.\n\nBeyond the apartment doors, Fountain Lake provides a resort-style experience. Enjoy amenities like our sparkling pool, fully-equipped fitness center, and serene courtyard, perfect for relaxation. Conveniently located near I-35, Fountain Lake ensures easy access to all Edmond has to offer. Schedule a visit today and find your ideal one-bedroom apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-daf1-73a3-b015-81aec27c1aaa",
        "storage_key": "property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Edmond, OK",
      "seo_description": "Find one bedroom apartments in Edmond, OK at Fountain Lake. Spacious layouts and luxury amenities await. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165605",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-oklahoma-county-fountain-lake",
      "search_query": "two bedroom apartments near Oklahoma County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Oklahoma County",
      "h2_subtitle": "Explore two bedroom apartments near Oklahoma County at Fountain Lake. Enjoy spacious living and great amenities.",
      "page_copy": "Discover the perfect two bedroom apartments near Oklahoma County at Fountain Lake, where spacious living meets luxury amenities. Our thoughtfully designed layouts offer generous space, making it ideal for families, roommates, or those who desire extra room. Each apartment is equipped with walk-in closets and ample storage to suit your lifestyle needs.\n\nLocated near I-35, Fountain Lake offers easy access to Oklahoma County and beyond, blending convenience with community charm. Enjoy resort-style living with our exceptional amenities, including a refreshing pool and modern fitness center. Come see why Fountain Lake is the prime choice for two-bedroom living in the Edmond area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-daf1-73a3-b015-81aec27c1aaa",
        "storage_key": "property/6767906449165605/019cfb40-daf1-73a3-b015-81aec27c1aaa.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Oklahoma County",
      "seo_description": "Find spacious two bedroom apartments near Oklahoma County at Fountain Lake. Discover luxury amenities and prime location today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5174"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-GBPDNYR44K"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151716"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/fountain-lake/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PS3R3ZNJ"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165605/019d1bd8-2a82-77bf-93d5-12c9d96f4399.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-580-1838"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "67c6a0999804a5e48867ffd6"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlNLOUluVVFaV0FicDVaUlhBME9oTGc9PSIsInZhbHVlIjoidE5zZDlLVm5JTzZtMHpCbER6MUE3QT09IiwibWFjIjoiZjliNzlhMmQ1MjQ2YjFlZDk4ZDM0MWRlY2QxYmM1NWIwODViY2UwNjJhYTQxMjVmNzBmODRhNmNiZjNkNjNjMSJ9"
    }
  ],
  "custom_qb_id": "5174",
  "custom_ga4_id": "G-GBPDNYR44K",
  "custom_repli_id": "10041151716",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/fountain-lake/register/",
  "custom_google_gtm_id": "GTM-PS3R3ZNJ",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165605/019d1bd8-2a82-77bf-93d5-12c9d96f4399.pdf",
  "custom_ppc_tracking_phone_number": "800-580-1838",
  "custom_residentboost_apartment_id": "67c6a0999804a5e48867ffd6",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlNLOUluVVFaV0FicDVaUlhBME9oTGc9PSIsInZhbHVlIjoidE5zZDlLVm5JTzZtMHpCbER6MUE3QT09IiwibWFjIjoiZjliNzlhMmQ1MjQ2YjFlZDk4ZDM0MWRlY2QxYmM1NWIwODViY2UwNjJhYTQxMjVmNzBmODRhNmNiZjNkNjNjMSJ9"
};

export const generatedAt = '2026-08-27T21:38:13.634Z';
